import {
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectionStrategy,
} from "@angular/core";
import { GridToolbarItem } from "src/app/shared/components/data-grid/data-grid.model";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { any } from "@amcharts/amcharts4/.internal/core/utils/Array";
import { AppsService } from "src/app/shared/services/apps.service";
import moment from "moment";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import { Router } from "@angular/router";
import { differenceInCalendarDays } from "date-fns";
import { NzDrawerPlacement } from "ng-zorro-antd/drawer";

// Our demo infrastructure requires us to use 'file-saver-es'. We recommend that you use the official 'file-saver' package in your applications.
// SECURITY (audit finding #9 - Formula Injection, CWE-1236)
import { NzMessageService } from "ng-zorro-antd/message";
import { jsPDF } from "jspdf";
import "src/app/shared/utils/jspdf-autotable";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

/* Chart code */
// Themes begin
am4core.useTheme(am4themes_animated);
// Themes end
@Component({
  selector: "app-ulb-dashboard",
  templateUrl: "./ulb-dashboard.component.html",
  styleUrls: ["./ulb-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UlbDashboardComponent implements OnInit, OnDestroy {
  /**
   * PDF export button, bound to <app-data-grid [toolbarItems]>.
   *
   * A memoised GETTER, not a field. The button was previously an <i nz-icon>
   * with `position: absolute; right: NNNpx` plus an *ngIf, and that *ngIf is
   * load-bearing: `this.canExportPdf` is not known at construction
   * time. A static array would capture the value before it is resolved and show
   * the button to everyone, or to no one.
   *
   * Memoised on the flag so the array identity is stable between change-detection
   * passes - it feeds an *ngFor.
   */
  get pdfToolbar(): GridToolbarItem[] {
    const on = !!this.canExportPdf;
    if (on !== this.pdfToolbarOn) {
      this.pdfToolbarOn = on;
      this.pdfToolbarCache = on
        ? [
            {
              icon: "file-pdf",
              hint: "Export PDF",
              onClick: () => this.downloadVehiclesPdf(),
            },
          ]
        : [];
    }
    return this.pdfToolbarCache;
  }
  private pdfToolbarOn: boolean | undefined = undefined;
  private pdfToolbarCache: GridToolbarItem[] = [];

  /**
   * PDF export button, bound to <app-data-grid [toolbarItems]>.
   *
   * Was an <i nz-icon> with `position: absolute; right: NNNpx; top: 2px`,
   * hand-calibrated to drop into a gap in DevExtreme's toolbar. That gap no
   * longer exists - the toolbar is left-aligned now - so the icon floated over
   * unrelated content. As a toolbar item it sits in the row with search, the
   * column chooser and Excel export, and needs no pixel tuning at all.
   */

  // Subject for unsubscribing from observables on component destroy
  private destroy$ = new Subject<void>();
  private timeoutHandles: any[] = []; // Track all setTimeout for cleanup

  chart: am4charts.XYChart;
  chart2: am4charts.XYChart;
  // chart3: am4charts.XYChart;
  // chart4: am4charts.XYChart;
  chart5: am4charts.XYChart;

  rtDvtdTripsDta: any;
  tripsTrvldDta: any;
  swprsWrkngTmDta: any;
  dateFormat = "dd/MM/yyyy";
  monthFormat = "yyyy/MM";

  rtDvtdTripscolumnDefs;
  tripsTrvldcolumnDefs;
  /**
   * Was <dxo-summary> with four <dxi-group-item [showInGroupFooter]="true"
   * [alignByColumn]="true"> on the trips grid. Same four aggregates, same
   * columns, rendered as a footer row per group by <app-data-grid>.
   */
  tripsGroupItems = [
    {
      column: "asrt_nm",
      summaryType: "count" as const,
      displayFormat: "Total Vehicles: {0}",
    },
    {
      column: "trp_sqnc_nu",
      summaryType: "count" as const,
      displayFormat: "Total Trips: {0}",
    },
    {
      column: "actl_trvl_dstne_ct",
      summaryType: "sum" as const,
      displayFormat: "Total Distance: {0}",
    },
    {
      column: "actl_trvl_tm",
      summaryType: "sum" as const,
      displayFormat: "Total Hours: {0}",
    },
  ];
  swprsWrkngTmcolumnDefs;
  // legend: am4charts.Legend;
  showLdr = false;
  private loadingCount = 0; // Track number of active API calls
  private hideLdrHandle: any = null; // Debounce handle for hiding the overlay
  tdyCoveredTrips: any;
  slctdDt = new Date();
  today = new Date();
  // PDF export (top-right toggle): collapsed icon <-> from/to date filter + Generate
  showPdfFilter = false;
  pdfFromDate: Date = moment().subtract(7, "days").toDate();
  pdfToDate: Date = new Date();
  ttlDstncCnt: any;
  ttlTrpsCnt: any;
  prmryTrpsCnt: any;
  scndryTrpsCnt: any;
  curTblDate: string;
  ctgryWseCnts: any;
  curTmspDate: string;
  clntDtls: any;
  tntLst: any = [];
  selectedtenant;
  selectedtenantNm;
  curYr: any;
  shwzrwErr: boolean = false;
  shwScndryzrwErr: boolean = false;
  cnt_dtlscolumnDefs: any;
  cvrgDta: any;
  HsDta: any;
  postCntdata: any;
  cnt_dtls: any;
  target;
  button_in = false;
  trnsfrPnts;
  trnsfrStns;
  prcngPnts;
  mrfPnts;
  rdrctUlbDtls;
  visible = false;
  driverSldrVisible = false;
  selectedDriverForSlider: any = null;
  placement: NzDrawerPlacement = "right";
  userDtls: any;
  clap_in: any;
  ShowClap: boolean = false;
  VndrwseopratedvehclesTble: any;
  VndrwseopratedvehclesTblecolumnDefs: any;
  dbrd_ky = "ulb";
  vehclesTble: any = [];
  vehclesTblecolumnDefs: any = [];
  ulb_id;
  nodata: boolean;
  nodataMsg: string;
  urban_in;
  hdrLbl: string;
  ttl_vhcls: any;
  tripsTrvldDtaDup: any;
  sbHdr: string = "";
  vehclesTbleDup: any = [];
  @ViewChild("tripsTable") tripsTableRef: ElementRef;
  @ViewChild("vehclesTable") vehclesTableRef: ElementRef;
  @ViewChild("operationalTable") operationalTableRef: ElementRef;
  trpsbHdr: string;
  filterPanelOpen = false;
  selectedCard: string = "vehicles"; // 'vehicles', 'operational', 'trips'
  operationalView: string = "table"; // 'table' or 'graph'
  tripsView: string = "table"; // 'table' or 'graph'

  // Cached counts for operational status - updated when data changes to avoid performance issues
  operatedCount: number = 0;
  notOperatedCount: number = 0;
  operatedPercentage: string = "0";

  // Cached counts for trips - updated when data changes
  totalTripsCount: number = 0;
  travelledTripsCount: number = 0;
  notTravelledTripsCount: number = 0;
  travelledTripsPercentage: string = "0";

  // Fuel card data
  fuelCardData: any = {
    totalUlbsFilled: 0,
    totalUlbsNotFilled: 0,
    totalLitres: 0,
    totalAmount: 0,
    totalEntries: 0,
    vehiclesCount: 0,
    diesel: { count: 0, litres: 0, amount: 0 },
    petrol: { count: 0, litres: 0, amount: 0 },
    cng: { count: 0, kg: 0, amount: 0 },
  };

  // Overall Vehicle Owner Type counts
  overallOwnerCounts: any = { own: 0, contract: 0, sac: 0 };
  primaryOwnerCounts: any = { own: 0, contract: 0, sac: 0 };
  secondaryOwnerCounts: any = { own: 0, contract: 0, sac: 0 };

  // VMU Maintained data
  vmuMaintainedData: any = {
    cdma: { total: 0, operated: 0, notOperated: 0, operatedPercent: 0 },
    ulb: { total: 0, operated: 0, notOperated: 0, operatedPercent: 0 },
  };

  // Driver Type Counts
  driverTypeCounts: any = {
    total: 0,
    own: 0,
    apcos: 0,
    contract: 0,
    own_attended: 0,
    own_not_attended: 0,
    apcos_attended: 0,
    apcos_not_attended: 0,
    contract_attended: 0,
    contract_not_attended: 0,
  };

  // Previous month fuel data
  prevMonthFuelData: any = {
    totalUlbsFilled: 0,
    totalUlbsNotFilled: 0,
    totalLitres: 0,
    totalAmount: 0,
    totalEntries: 0,
    vehiclesCount: 0,
    diesel: { count: 0, litres: 0, amount: 0 },
    petrol: { count: 0, litres: 0, amount: 0 },
    cng: { count: 0, kg: 0, amount: 0 },
  };
  currentMonthLabel: string = "";
  previousMonthLabel: string = "";

  // Fuel Last 7 Days chart
  fuelLast7DaysData: any[] = [];
  chart6: am4charts.XYChart;

  // Number formatters
  currencyFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  numberFormatter = new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  // Top 10 and Least 10 operated vehicles
  top10OperatedVehicles: any[] = [];
  least10OperatedVehicles: any[] = [];

  // Vehicle Live Status data
  vehicleLiveStatus: any = {
    total: 0,
    online: 0,
    running: 0,
    offline: 0,
    parked: 0,
    repair: 0,
    standby24hr: 0,
    onlineStandby24hr: 0,
    offline24hr: 0,
    others: 0,
  };

  // Method to update operational counts - call this when vehclesTbleDup changes
  updateOperationalCounts(): void {
    if (!this.vehclesTbleDup || this.vehclesTbleDup.length === 0) {
      this.operatedCount = 0;
      this.notOperatedCount = 0;
      this.operatedPercentage = "0";
      return;
    }
    this.operatedCount = this.vehclesTbleDup.filter(
      (k: any) => k.opr_in == 1
    ).length;
    this.notOperatedCount = this.vehclesTbleDup.filter(
      (k: any) => k.opr_in == 0
    ).length;
    const total = this.operatedCount + this.notOperatedCount;
    this.operatedPercentage =
      total === 0 ? "0" : ((this.operatedCount / total) * 100).toFixed(1);
  }

  // Method to compute top 10 and least 10 operated vehicles by distance
  calculateTopLeast10Vehicles(): void {
    if (!this.vehclesTbleDup || this.vehclesTbleDup.length === 0) {
      this.top10OperatedVehicles = [];
      this.least10OperatedVehicles = [];
      return;
    }
    // Filter out spare vehicles and map with distance
    const vehicles = this.vehclesTbleDup
      .filter((v: any) => v.asrt_spre_in != 1)
      .map((v: any) => ({
        asrt_nm: v.asrt_nm,
        crw_nm: v.crw_nm || "-",
        tdy_trvl_dst: parseFloat(v.tdy_trvl_dst) || 0,
        opr_in: v.opr_in,
        opr_sts_nm:
          v.opr_sts_nm || (v.opr_in == 1 ? "Operated" : "Not Operated"),
        tdy_trvl_trps: v.tdy_trvl_trps || 0,
        asgnd_trps: v.asgnd_trps || 0,
      }));

    // Top 10: highest distance
    const sortedDesc = [...vehicles].sort(
      (a, b) => b.tdy_trvl_dst - a.tdy_trvl_dst
    );
    this.top10OperatedVehicles = sortedDesc
      .slice(0, 10)
      .map((v, i) => ({ ...v, sno: i + 1 }));

    // Least 10: lowest distance
    const sortedAsc = [...vehicles].sort(
      (a, b) => a.tdy_trvl_dst - b.tdy_trvl_dst
    );
    this.least10OperatedVehicles = sortedAsc
      .slice(0, 10)
      .map((v, i) => ({ ...v, sno: i + 1 }));
  }

  // Method to update trips counts - call this when tripsTrvldDtaDup changes
  updateTripsCounts(): void {
    if (!this.tripsTrvldDtaDup || this.tripsTrvldDtaDup.length === 0) {
      this.totalTripsCount = 0;
      this.travelledTripsCount = 0;
      this.notTravelledTripsCount = 0;
      this.travelledTripsPercentage = "0";
      return;
    }
    this.totalTripsCount = this.tripsTrvldDtaDup.length;
    // Travelled trips: both start and close flags are 1
    this.travelledTripsCount = this.tripsTrvldDtaDup.filter(
      (k: any) => k.trp_strt_in == 1 && k.trp_cls_in == 1
    ).length;
    this.notTravelledTripsCount =
      this.totalTripsCount - this.travelledTripsCount;
    this.travelledTripsPercentage =
      this.totalTripsCount === 0
        ? "0"
        : ((this.travelledTripsCount / this.totalTripsCount) * 100).toFixed(1);
  }

  constructor(
    public apiServ: AppsService,
    public TransfereService: TransfereService,
    public route: Router,
    private message: NzMessageService
  ) {
    this.rdrctUlbDtls = [];
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.rdrctUlbDtls = this.TransfereService.getLoclData("ulbDta");
    if (this.rdrctUlbDtls) {
      this.button_in = true;
    }
    // console.log(this.rdrctUlbDtls);
    this.clntDtls[0].tnts.forEach((element) => {
      if (element.urban_in == 1) {
        this.tntLst.push(element);
      }
    });
    if (this.rdrctUlbDtls) {
      // this.curDate = moment(this.rdrctUlbDtls.frmtd_dt).format('YYYY-MM-DD');
      // this.selectedtenant = moment(this.rdrctUlbDtls.tnt_id).format('YYYY-MM-DD');
      this.ontntSelect(this.rdrctUlbDtls.tnt_id);
      // this.selectedtenant = this.rdrctUlbDtls.tnt_id;
      // this.selectedtenantNm = this.rdrctUlbDtls.tnt_dsply_nm;
    } else {
      this.selectedtenant = this.tntLst[0].tnt_id;
      this.selectedtenantNm = this.tntLst[0].tnt_dsply_nm;
      this.ulb_id = this.tntLst[0].cpy_ulb_id;
      this.urban_in = this.tntLst[0].urban_in;
      // console.log(this.selectedtenant, this.selectedtenantNm);
    }
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    this.clap_in = this.userDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
    }
    if (this.urban_in == 1) {
      this.hdrLbl = "ULB";
    } else {
      this.hdrLbl = "Mandal";
    }
  }
  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, this.today) > 0;
  };

  // ---- PDF export (Tirupathi tenant only) ----
  // Button is shown only when the current ULB is Tirupathi (tnt 7 / name match).
  get isTirupatiTenant(): boolean {
    const nm = (this.selectedtenantNm || this.hdrLbl || "").toString();
    return this.selectedtenant == 7 || /tirupath/i.test(nm);
  }

  // ---- PDF access control ----
  // PDF view/generate/download is restricted to admins: super-admin,
  // client-admin or tenant-admin (same rule as role-guard.service.ts isAdmin
  // and the backend `requireAdmin` gate). Non-admins never see the buttons and
  // the methods refuse to run even if invoked directly.
  get canExportPdf(): boolean {
    const u = this.userDtls || {};
    const c = (this.clntDtls && this.clntDtls[0]) || {};
    const tntAdmin =
      Array.isArray(c.tnts) &&
      c.tnts.some((t: any) => Number(t.tnt_admn_in) === 1);
    return (
      Number(u.spr_admn_in) === 1 ||
      Number(c.spr_admn_in) === 1 ||
      Number(u.clnt_admn_in) === 1 ||
      Number(c.clnt_admn_in) === 1 ||
      tntAdmin
    );
  }

  // Show/hide the from/to date filter row. Opening it resets to a 1-week range.
  togglePdfFilter(): void {
    this.showPdfFilter = !this.showPdfFilter;
    if (this.showPdfFilter) {
      this.pdfToDate = new Date();
      this.pdfFromDate = moment().subtract(7, "days").toDate(); // 1-week gap
    }
  }

  // Load an assets image as a PNG dataURL so jsPDF can embed it.
  private loadImageAsDataUrl(path: string): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        } catch {
          resolve("");
        }
      };
      img.onerror = () => resolve("");
      img.src = path;
    });
  }

  // snake_case column key -> readable init-cap header
  // e.g. "vehicle_registration_number" -> "Vehicle Registration Number", "sno" -> "S.No"
  private headerLabel(key: string): string {
    const special: any = {
      sno: "S.No",
      km: "KM",
      id: "ID",
      ulb: "ULB",
      no: "No",
      vmu: "VMU",
    };
    return String(key)
      .split("_")
      .map(
        (w) =>
          special[w.toLowerCase()] || w.charAt(0).toUpperCase() + w.slice(1)
      )
      .join(" ");
  }

  // Build + download the branded Vehicle Monitoring Report (server-rendered).
  // POSTs { from_dt, to_dt, slctd_tnt } to the EJS -> PDF endpoint and saves
  // the returned PDF binary. All six tables (Distance, Working Hours, Coverage
  // Primary/Secondary, Daily Trips, Fuel) are filled server-side from the
  // report models, so there is no silent client-side empty-table failure.
  async generatePdf(): Promise<void> {
    if (!this.canExportPdf) {
      this.message.create(
        "error",
        "Access denied. You do not have permission to generate PDF reports."
      );
      return;
    }
    const fromIso = moment(this.pdfFromDate).format("YYYY-MM-DD");
    const toIso = moment(this.pdfToDate).format("YYYY-MM-DD");
    const fromDisp = moment(this.pdfFromDate).format("DD-MM-YYYY");
    const toDisp = moment(this.pdfToDate).format("DD-MM-YYYY");
    const tnt = Number(this.selectedtenant) || 0;
    this.showLdr = true;
    try {
      const blob: Blob = (await this.apiServ
        .postBlobType(
          { from_dt: fromIso, to_dt: toIso, slctd_tnt: tnt },
          "dashboard/enterprise/report/ulb_vehicle_pdf"
        )
        .toPromise()) as Blob;
      if (!blob || blob.size === 0) {
        throw new Error("empty pdf");
      }

      // The endpoint streams a real PDF on success but JSON/HTML on error
      // (e.g. 404 if the server route isn't loaded, or a render failure).
      // Verify the magic bytes are "%PDF" before saving — otherwise read the
      // body as text and surface the real reason instead of a broken file.
      const head = await blob.slice(0, 5).text();
      const isPdf =
        head.indexOf("%PDF") === 0 || (blob.type || "").indexOf("pdf") > -1;
      if (!isPdf) {
        let serverMsg = "";
        try {
          const txt = await blob.text();
          try {
            serverMsg = (
              JSON.parse(txt).message ||
              JSON.parse(txt).error ||
              ""
            ).toString();
          } catch {
            serverMsg = txt.slice(0, 160);
          }
        } catch {
          /* ignore */
        }
        this.message.create(
          "error",
          `Report service did not return a PDF. ${
            serverMsg ||
            "Ensure the API server has been restarted to load the report route."
          }`
        );
        return;
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Tirupathi-ULB-Report_${fromDisp}_to_${toDisp}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (e: any) {
      // Surface the real failure instead of the generic message so we can
      // tell apart: (a) Node down / route not loaded, (b) puppeteer/EJS
      // render error, (c) SQL error in one of the report models, (d) the
      // super-admin authorisation gate (403). Prefer the server-provided
      // message; fall back to a short generic one.
      // eslint-disable-next-line no-console
      console.error("[ULB PDF] generatePdf failed:", e);

      /* Auth / permission failures — use the SERVER's status meaning:
           403 → SESSION_EXPIRED or INVALID_TOKEN (see hasToken middleware in
                 server/api/modules/auth/validators/accessCtrl.js).
                 The user needs to log in again — NOT a permission problem.
           404 → ACCESS_DENIED — the real "no permission" case.
           406 → UN_AUTH_ACCESS — origin mismatch or missing token.
         The prior code labelled every 403 as "no permission" which read as
         a permission bug when it was really an expired session. */
      if (e && e.status === 403) {
        this.message.create(
          "error",
          "Your session has expired. Please log in again to generate the report."
        );
        return;
      }
      if (e && (e.status === 404 || e.status === 406)) {
        this.message.create(
          "error",
          "Access denied. You do not have permission to generate this report."
        );
        return;
      }

      var detail = "";
      try {
        // For responseType:'blob' errors, HttpErrorResponse.error is a Blob —
        // read it as text and pull out the server's JSON `message`.
        if (e && e.error instanceof Blob) {
          const txt = await e.error.text();
          try {
            detail = (
              JSON.parse(txt).message ||
              JSON.parse(txt).err_message ||
              ""
            ).toString();
          } catch {
            detail = (txt || "").slice(0, 160);
          }
        } else if (e && e.error && typeof e.error === "object") {
          // HttpErrorResponse — try to read JSON body
          detail =
            e.error.message ||
            e.error.err_message ||
            (Array.isArray(e.error.errors) &&
              e.error.errors[0] &&
              e.error.errors[0].message) ||
            "";
        } else if (e && e.message) {
          detail = e.message;
        } else if (typeof e === "string") {
          detail = e;
        }
        if (!detail && e && e.status) {
          detail = `HTTP ${e.status}${e.statusText ? " " + e.statusText : ""}`;
        }
      } catch {
        /* ignore */
      }
      this.message.create(
        "error",
        detail
          ? `Could not generate the report: ${detail}`
          : "Could not generate the report. Please try again."
      );
    } finally {
      this.showLdr = false;
      this.showPdfFilter = false;
    }
  }

  // Legacy client-side jsPDF builder (kept as an offline fallback; the active
  // Generate PDF button now calls the server-rendered generatePdf() above).
  async generatePdfLegacy(): Promise<void> {
    if (!this.canExportPdf) {
      this.message.create(
        "error",
        "Access denied. You do not have permission to generate PDF reports."
      );
      return;
    }
    const fromIso = moment(this.pdfFromDate).format("YYYY-MM-DD");
    const toIso = moment(this.pdfToDate).format("YYYY-MM-DD");
    const fromDisp = moment(this.pdfFromDate).format("DD-MM-YYYY");
    const toDisp = moment(this.pdfToDate).format("DD-MM-YYYY");
    const tnt = Number(this.selectedtenant) || 0;
    this.showLdr = true;
    try {
      // preload logos (header)
      const [tptLogo, weLogo] = await Promise.all([
        this.loadImageAsDataUrl("assets/images/logo/tirupati_municipal.jpg"),
        this.loadImageAsDataUrl("assets/images/logo/icon.png"),
      ]);

      // ---- Fetch all 4 report APIs in parallel ----
      // The 4 backend routes (POST) take { from_dt, to_dt, slctd_tnt } and
      // return { status, data: [...] }. We log per-route so a 0-row outcome
      // can be distinguished from a network/auth failure when debugging.
      const body: any = { from_dt: fromIso, to_dt: toIso, slctd_tnt: tnt };
      const safeFetch = async (
        label: string,
        route: string
      ): Promise<any[]> => {
        try {
          const res: any = await this.apiServ.post(body, route).toPromise();
          const rows =
            res && res.status == 200 && Array.isArray(res.data) ? res.data : [];
          // eslint-disable-next-line no-console
          console.log(
            `[ULB PDF] ${label}: status=${res && res.status}, rows=${
              rows.length
            }`
          );
          return rows;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.warn(`[ULB PDF] ${label} failed:`, e);
          return [];
        }
      };
      const [distWrkRows, coverageRows, dailyTripsRows, fuelRows] =
        await Promise.all([
          safeFetch(
            "distance/working-hours",
            "dashboard/enterprise/report/vehicle_distance_working_hours"
          ),
          safeFetch("coverage", "dashboard/enterprise/report/vehicle_coverage"),
          safeFetch(
            "daily trips",
            "dashboard/enterprise/report/daily_trip_details"
          ),
          safeFetch("fuel", "dashboard/enterprise/report/vehicle_fuel"),
        ]);

      // Distance: blng_prmtr_id = 1; Working Hours: blng_prmtr_id = 2.
      const reseq = (rows: any[]) => rows.map((r, i) => ({ ...r, sno: i + 1 }));
      const distanceData = reseq(
        distWrkRows.filter((r) => Number(r.blng_prmtr_id) === 1)
      );
      const workingHoursData = reseq(
        distWrkRows.filter((r) => Number(r.blng_prmtr_id) === 2)
      );
      // Backend's SQL (trp_rn_dtl_t.trp_type_id) returns 1000000=Primary,
      // 1000001=Secondary along with a computed trip_type_lbl label. Match on
      // the label first; numeric fallback uses the live id range.
      const coveragePrimary = reseq(
        coverageRows.filter(
          (r) =>
            r.trip_type_lbl === "Primary" || Number(r.trp_type_id) === 1000000
        )
      );
      const coverageSecondary = reseq(
        coverageRows.filter(
          (r) =>
            r.trip_type_lbl === "Secondary" || Number(r.trp_type_id) === 1000001
        )
      );

      // Surface to the user when nothing came back at all — common cause is
      // the Node server still running pre-restart code (routes 404) or the
      // selected ULB has no data in the picked range. The PDF still renders
      // so the toast is informational, not blocking.
      const totalRows =
        distWrkRows.length +
        coverageRows.length +
        dailyTripsRows.length +
        fuelRows.length;
      if (totalRows === 0) {
        try {
          this.message.create(
            "warning",
            "No data returned by any report API. Check server logs and that the date range covers active days."
          );
        } catch {
          /* ignore */
        }
      }

      // ---- Per-section spec: header text + column list ----
      // Header format follows "<Report Name> {fromDisp} to {toDisp}" per spec.
      const period = `${fromDisp} to ${toDisp}`;
      // Distinct vehicles in the first (Distance) table — shown as a footer summary row.
      const distanceVehCount = new Set(distanceData.map((r) => r.asrt_nm)).size;
      const sections: Array<{
        title: string;
        header: string;
        rows: any[];
        summary?: string;
        columns: Array<{ header: string; field: string }>;
      }> = [
        {
          title: "Vehicle-wise Distance",
          header: `Vehicle Distance Report ${period}`,
          summary: `Total Vehicles: ${distanceVehCount}`,
          rows: distanceData,
          columns: [
            { header: "S.No", field: "sno" },
            { header: "Vehicle", field: "asrt_nm" },
            { header: "ULB", field: "tnt_dsply_nm" },
            { header: "Category", field: "asrt_ctgry_nm" },
            { header: "Default Mileage (km/day)", field: "default_milage" },
            { header: "Travelled Distance (km)", field: "travelled_dist" },
            { header: "Expected Mileage (km)", field: "expected_milage" },
            { header: "Total Mileage (km)", field: "total_milage" },
          ],
        },
        {
          title: "Vehicle-wise Working Hours",
          header: `Vehicle Working Hours Report ${period}`,
          rows: workingHoursData,
          columns: [
            { header: "S.No", field: "sno" },
            { header: "Vehicle", field: "asrt_nm" },
            { header: "ULB", field: "tnt_dsply_nm" },
            { header: "Category", field: "asrt_ctgry_nm" },
            { header: "Days", field: "days" },
            { header: "Working Hours (hrs)", field: "working_hours" },
          ],
        },
        {
          title: "Trip Coverage — Primary",
          header: `Vehicle Coverage Report (Primary) ${period}`,
          rows: coveragePrimary,
          columns: [
            { header: "S.No", field: "sno" },
            { header: "Vehicle", field: "asrt_nm" },
            { header: "ULB", field: "tnt_dsply_nm" },
            { header: "Defined Trips", field: "defined_trips" },
            { header: "Travelled Trips", field: "travelled_trips" },
            { header: "Closed Trips", field: "closed_trips" },
            { header: "Deviated Trips", field: "deviated_trips" },
            { header: "Coverage %", field: "coverage_pct" },
          ],
        },
        {
          title: "Trip Coverage — Secondary",
          header: `Vehicle Coverage Report (Secondary) ${period}`,
          rows: coverageSecondary,
          columns: [
            { header: "S.No", field: "sno" },
            { header: "Vehicle", field: "asrt_nm" },
            { header: "ULB", field: "tnt_dsply_nm" },
            { header: "Defined Trips", field: "defined_trips" },
            { header: "Travelled Trips", field: "travelled_trips" },
            { header: "Closed Trips", field: "closed_trips" },
            { header: "Deviated Trips", field: "deviated_trips" },
            { header: "Coverage %", field: "coverage_pct" },
          ],
        },
        {
          title: "Daily Trip Details",
          header: `Daily Trip Details Report ${period}`,
          rows: dailyTripsRows,
          columns: [
            { header: "S.No", field: "sno" },
            { header: "Date", field: "trp_dt_display" },
            { header: "Vehicles", field: "vehicles_ct" },
            { header: "Defined", field: "defined_trips" },
            { header: "Travelled", field: "travelled_trips" },
            { header: "Not Travelled", field: "not_travelled" },
            { header: "Closed", field: "closed_trips" },
            { header: "Deviated", field: "deviated_trips" },
            { header: "Travelled %", field: "travelled_pct" },
          ],
        },
        {
          title: "Vehicle-wise Fuel",
          header: `Vehicle Fuel Report ${period}`,
          rows: fuelRows,
          columns: [
            { header: "S.No", field: "sno" },
            { header: "Vehicle", field: "asrt_nm" },
            { header: "ULB", field: "tnt_dsply_nm" },
            { header: "Category", field: "asrt_ctgry_nm" },
            { header: "Entries", field: "entries" },
            { header: "Petrol (L)", field: "petrol_lt" },
            { header: "Diesel (L)", field: "diesel_lt" },
            { header: "CNG (L)", field: "cng_lt" },
            { header: "Total (L)", field: "total_lt" },
            { header: "Amount (Rs)", field: "total_amount" },
          ],
        },
      ];

      const doc: any = new jsPDF("p", "mm", "a4");
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();

      // Header band + footer drawn on every content page
      const drawFurniture = () => {
        if (tptLogo) {
          doc.addImage(tptLogo, "PNG", 14, 6, 16, 16);
        }
        if (weLogo) {
          doc.addImage(weLogo, "PNG", pageW - 25, 8, 11, 11);
        }
        doc.setFont("helvetica", "bold");
        doc.setFontSize(13);
        doc.setTextColor(30, 41, 59);
        doc.text("TIRUPATHI MUNICIPAL CORPORATION", pageW / 2, 13, {
          align: "center",
        });
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.setTextColor(71, 85, 105);
        doc.text("Vehicle Monitoring Report", pageW / 2, 19, {
          align: "center",
        });
        doc.setDrawColor(37, 99, 235);
        doc.setLineWidth(0.6);
        doc.line(14, 24, pageW - 14, 24);
        doc.setFontSize(7);
        doc.setTextColor(120, 120, 120);
        doc.text(
          `Generated ${moment().format("DD-MM-YYYY HH:mm")}`,
          14,
          pageH - 8
        );
        doc.text("Powered by Wetrackon", pageW / 2, pageH - 8, {
          align: "center",
        });
      };

      // ---- Cover page ----
      if (tptLogo) {
        doc.addImage(tptLogo, "PNG", pageW / 2 - 22, 30, 44, 44);
      }
      doc.setFont("helvetica", "bold");
      doc.setFontSize(20);
      doc.setTextColor(30, 41, 59);
      doc.text("TIRUPATHI MUNICIPAL CORPORATION", pageW / 2, 90, {
        align: "center",
        maxWidth: pageW - 28,
      });
      doc.setFontSize(15);
      doc.setTextColor(37, 99, 235);
      doc.text("Vehicle Monitoring Report", pageW / 2, 102, {
        align: "center",
      });
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
      doc.setTextColor(71, 85, 105);
      doc.text(
        `Report # ULB-TPT-${moment().format("YYYYMMDDHHmmss")}`,
        pageW / 2,
        116,
        { align: "center" }
      );
      doc.text(`Period: ${fromDisp}  to  ${toDisp}`, pageW / 2, 124, {
        align: "center",
      });
      doc.text(
        `Generated on ${moment().format("DD-MM-YYYY HH:mm")}`,
        pageW / 2,
        132,
        { align: "center" }
      );
      if (weLogo) {
        doc.addImage(weLogo, "PNG", pageW / 2 - 6, pageH - 32, 12, 12);
      }

      // ALL sections always render (per spec: "strictly in contents and in pdf").
      // Empty sections still appear in the TOC and in the body with a single
      // "No data available for this period" row under the column headers.

      // ---- Table of Contents ----
      doc.addPage();
      drawFurniture();
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
      doc.setTextColor(30, 41, 59);
      doc.text("Table of Contents", 14, 36);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor(51, 65, 85);
      let ty = 46;
      sections.forEach((s, i) => {
        const count = Array.isArray(s.rows) ? s.rows.length : 0;
        doc.text(
          `${i + 1}.  ${s.title}   (${count} ${count === 1 ? "row" : "rows"})`,
          16,
          ty
        );
        ty += 7;
      });

      // ---- Sections — one table per section, each with its own relevant header ----
      sections.forEach((s) => {
        doc.addPage();
        drawFurniture();
        doc.setFont("helvetica", "bold");
        doc.setFontSize(13);
        doc.setTextColor(37, 99, 235);
        doc.text(s.header, pageW / 2, 32, { align: "center" });
        const hasRows = Array.isArray(s.rows) && s.rows.length > 0;
        const body = hasRows
          ? s.rows.map((r) =>
              s.columns.map((c) => (r[c.field] != null ? r[c.field] : ""))
            )
          : [
              ["No data available for this period"].concat(
                new Array(s.columns.length - 1).fill("")
              ),
            ];
        // Optional footer summary row spanning all columns (e.g. "Total Vehicles: N").
        const foot = s.summary
          ? [
              [
                {
                  content: s.summary,
                  colSpan: s.columns.length,
                  styles: {
                    halign: "left",
                    fontStyle: "bold",
                    fillColor: [226, 232, 240],
                    textColor: [30, 41, 59],
                  },
                },
              ],
            ]
          : undefined;
        doc.autoTable({
          startY: 36,
          margin: { top: 30, left: 10, right: 10, bottom: 14 },
          head: [s.columns.map((c) => c.header)],
          body,
          foot,
          showFoot: foot ? "lastPage" : "never",
          styles: { fontSize: 7, cellPadding: 1.4, overflow: "linebreak" },
          headStyles: { fillColor: [37, 99, 235], textColor: 255 },
          alternateRowStyles: { fillColor: [243, 246, 252] },
          theme: "grid",
          didDrawPage: () => drawFurniture(),
        });
      });

      // page numbers removed per user request

      doc.save(`Tirupathi-ULB-Report_${fromDisp}_to_${toDisp}.pdf`);
    } catch (e) {
      this.message.create(
        "error",
        "Could not generate the report. Please try again."
      );
    } finally {
      this.showLdr = false;
      this.showPdfFilter = false;
    }
  }

  selectedVehicle;
  close(): void {
    this.visible = false;
  }
  getVehDashSldr(evnt) {
    // console.log(evnt)
    if (evnt && evnt.column && evnt.data) {
      const columnField = evnt.column.dataField;
      // Open vehicle slider when clicking on vehicle name column
      if (columnField === "asrt_nm" || evnt.columnIndex == 2) {
        this.selectedVehicle = evnt.data;
        this.visible = true;
      }
      // Open driver slider when clicking on driver name column
      if (columnField === "crw_nm") {
        this.openDriverSlider(evnt.data);
      }
    }
  }
  ontntSelect(value) {
    if (value == 0) {
      this.selectedtenant = 0;
      this.selectedtenantNm = "All ULB's Selected";
      this.ulb_id = 0;
    }
    for (let i = 0; i < this.tntLst.length; i++) {
      // console.log('in');
      if (this.tntLst[i].tnt_id == value) {
        this.selectedtenant = this.tntLst[i].tnt_id;
        this.selectedtenantNm = this.tntLst[i].tnt_dsply_nm;
        this.ulb_id = this.tntLst[i].cpy_ulb_id;
        this.urban_in = this.tntLst[i].urban_in;
        if (this.urban_in == 1) {
          this.hdrLbl = "ULB";
        } else {
          this.hdrLbl = "Mandal";
        }
      }
    }

    // Hold the loader for the whole staggered sequence (released at the end of
    // batch 3) so the overlay does not flash off between batches.
    this.startLoading();

    // Batch 1: Core card data (immediate)
    this.get_today_Ulb_CoveredTripsCount(this.slctdDt, this.selectedtenant);
    this.get_totalDistanceCount(this.slctdDt, this.selectedtenant);
    this.get_totalTripsCount(this.slctdDt, this.selectedtenant);
    this.get_prmryTripsCount(this.slctdDt, this.selectedtenant);
    this.get_scndryTripsCount(this.slctdDt, this.selectedtenant);
    this.get_ctgrywisecounts(this.slctdDt, this.selectedtenant);
    this.getVehicleswiseData(this.slctdDt, this.selectedtenant);

    // Batch 2: Tables + card APIs (300ms delay)
    this.timeoutHandles.push(
      setTimeout(() => {
        this.get_Trips_trvalledDetails(this.slctdDt, this.selectedtenant);
        this.get_routeDvtdTripsDetails(this.slctdDt, this.selectedtenant);
        this.getVehiclesOperatedcntsVndrULBwise(
          this.slctdDt,
          this.selectedtenant
        );
        this.getFuelCardData(this.slctdDt, this.selectedtenant);
        this.getVehicleLiveStatus(this.selectedtenant);
        this.getVmuMaintainedData();
        this.getDriverTypeCounts();
        this.getFuelSummaryMonthly();
      }, 300)
    );

    // Batch 3: Charts (1000ms delay)
    this.timeoutHandles.push(
      setTimeout(() => {
        this.get_lst7DaysDistanceDta(this.slctdDt, this.selectedtenant);
        if (this.clntDtls[0].clnt_id != 3000001) {
          this.get_lst7DaysTrpsDta(this.slctdDt, this.selectedtenant);
          this.getFuelLast7DaysData();
        }
        this.stopLoading(); // release the sequence hold taken above
      }, 1000)
    );
  }
  onChange(e): void {
    this.slctdDt = e;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.curTblDate = moment(this.slctdDt).format("DD-MM-YYYY");

    // Hold the loader across the staggered batches (released at end of batch 3).
    this.startLoading();

    // Batch 1: Core data (immediate)
    this.get_today_Ulb_CoveredTripsCount(this.slctdDt, this.selectedtenant);
    this.get_totalDistanceCount(this.slctdDt, this.selectedtenant);
    this.get_totalTripsCount(this.slctdDt, this.selectedtenant);
    this.get_prmryTripsCount(this.slctdDt, this.selectedtenant);
    this.get_scndryTripsCount(this.slctdDt, this.selectedtenant);
    this.get_ctgrywisecounts(this.slctdDt, this.selectedtenant);
    this.getVehicleswiseData(this.slctdDt, this.selectedtenant);
    this.get_SolidwasteTripsCount(this.slctdDt);

    // Batch 2: Card data + tables (300ms delay)
    this.timeoutHandles.push(
      setTimeout(() => {
        this.get_Trips_trvalledDetails(this.slctdDt, this.selectedtenant);
        this.get_routeDvtdTripsDetails(this.slctdDt, this.selectedtenant);
        this.getVehiclesOperatedcntsVndrULBwise(
          this.slctdDt,
          this.selectedtenant
        );
        this.getFuelCardData(this.slctdDt, this.selectedtenant);
        this.getVehicleLiveStatus(this.selectedtenant);
        this.getVmuMaintainedData();
        this.getDriverTypeCounts();
        this.getFuelSummaryMonthly();
      }, 300)
    );

    // Batch 3: Charts (1000ms delay)
    this.timeoutHandles.push(
      setTimeout(() => {
        this.get_lst7DaysDistanceDta(this.slctdDt, this.selectedtenant);
        if (this.clntDtls[0].clnt_id != 3000001) {
          this.get_lst7DaysTrpsDta(this.slctdDt, this.selectedtenant);
          this.getFuelLast7DaysData();
        }
        this.stopLoading(); // release the sequence hold taken above
      }, 1000)
    );
  }

  // Helper methods for managing loading state.
  //
  // ds-loading is a full-screen fixed overlay, so every showLdr false->true
  // flip repaints the whole page. The dashboard fires its APIs in staggered
  // batches (see ngOnInit / onChange / ontntSelect), which used to let the
  // reference count drain to 0 in the gaps between batches — the overlay was
  // torn down and re-created 3+ times per refresh, which is what showed up as
  // the dashboard "blinking". Two guards prevent that:
  //   1. each batched sequence takes a hold (startLoading before batch 1,
  //      released at the end of the last batch) so the count never hits 0
  //      mid-sequence;
  //   2. hiding is debounced, so a brief dip to 0 does not flash the overlay.
  private startLoading(): void {
    this.loadingCount++;
    if (this.hideLdrHandle) {
      clearTimeout(this.hideLdrHandle);
      this.hideLdrHandle = null;
    }
    this.showLdr = true;
  }

  private stopLoading(): void {
    this.loadingCount--;
    if (this.loadingCount > 0) {
      return;
    }
    this.loadingCount = 0;
    if (this.hideLdrHandle) {
      clearTimeout(this.hideLdrHandle);
    }
    this.hideLdrHandle = setTimeout(() => {
      this.hideLdrHandle = null;
      if (this.loadingCount <= 0) {
        this.showLdr = false;
      }
    }, 400);
  }

  // *ngFor over a response array that is replaced wholesale on every refresh
  // recreates every card unless tracked by index — and a recreated .ulb-card
  // replays its cardSlideUp entrance animation, i.e. the cards flash.
  trackByIndex(index: number): number {
    return index;
  }

  ngOnInit() {
    this.curYr = moment(this.today).format("YYYY");
    this.slctdDt = new Date();
    this.curTblDate = moment(this.slctdDt).format("DD-MM-YYYY");

    // If constructor already called ontntSelect (via rdrctUlbDtls), skip loading here
    // to avoid firing 30+ simultaneous API calls
    if (this.rdrctUlbDtls) {
      return;
    }

    // Hold the loader across the staggered batches (released at end of batch 3).
    this.startLoading();

    // Batch 1: Essential card data (immediate)
    this.get_today_Ulb_CoveredTripsCount(this.slctdDt, this.selectedtenant);
    this.get_totalDistanceCount(this.slctdDt, this.selectedtenant);
    this.get_totalTripsCount(this.slctdDt, this.selectedtenant);
    this.get_prmryTripsCount(this.slctdDt, this.selectedtenant);
    this.get_scndryTripsCount(this.slctdDt, this.selectedtenant);
    this.get_ctgrywisecounts(this.slctdDt, this.selectedtenant);
    this.getVehicleswiseData(this.slctdDt, this.selectedtenant);

    // Batch 2: Secondary data + card APIs (500ms delay)
    this.timeoutHandles.push(
      setTimeout(() => {
        this.get_SolidwasteTripsCount(this.slctdDt);
        this.get_Trips_trvalledDetails(this.slctdDt, this.selectedtenant);
        this.get_routeDvtdTripsDetails(this.slctdDt, this.selectedtenant);
        this.getVehiclesOperatedcntsVndrULBwise(
          this.slctdDt,
          this.selectedtenant
        );
        this.getVehicleLiveStatus(this.selectedtenant);
        this.getVmuMaintainedData();
        this.getDriverTypeCounts();
        this.getFuelSummaryMonthly();
      }, 500)
    );

    // Batch 3: Charts (1500ms delay - DOM needs to be ready)
    this.timeoutHandles.push(
      setTimeout(() => {
        this.get_lst7DaysDistanceDta(this.slctdDt, this.selectedtenant);
        if (this.clntDtls[0].clnt_id != 3000001) {
          this.get_lst7DaysTrpsDta(this.slctdDt, this.selectedtenant);
          this.getFuelLast7DaysData();
        }
        this.stopLoading(); // release the sequence hold taken above
      }, 1500)
    );
  }

  curDate;
  postslctdDt;

  get_today_Ulb_CoveredTripsCount(funDt?, slctTnt?): any {
    // NOTE: tdyCoveredTrips is NOT cleared here. Both card rows are gated on
    // *ngIf="tdyCoveredTrips?.length", so blanking it before the request tore
    // down all 8 cards and replayed their cardSlideUp entrance animation on
    // every refresh — a visible flash. The array is replaced once the response
    // arrives (and emptied only if the response really has no rows).
    this.startLoading();
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/ulb_tdy/${this.dbrd_ky}`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            if (res_data && res_data.length > 0) {
              this.tdyCoveredTrips = res["data"];
              // Extract owner counts from ulb_tdy response
              const d = res_data[0];
              this.overallOwnerCounts = {
                own: d.own_ct || 0,
                contract: d.contract_ct || 0,
                sac: d.sac_ct || 0,
              };
              this.primaryOwnerCounts = {
                own: d.primary_own || 0,
                contract: d.primary_contract || 0,
                sac: d.primary_sac || 0,
              };
              this.secondaryOwnerCounts = {
                own: d.secondary_own || 0,
                contract: d.secondary_contract || 0,
                sac: d.secondary_sac || 0,
              };
            } else {
              this.tdyCoveredTrips = [];
            }
          }
          this.stopLoading();
        },
        (err) => {
          this.stopLoading();
          // console.log(err);
        }
      );
  }

  get_totalDistanceCount(funDt?, slctTnt?): any {
    this.ttlDstncCnt = [];
    this.startLoading();
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 1,
      slctd_tnt: slctTnt,
    };
    const rte = `dashboard/enterprise/get_ttlDstnce/${this.dbrd_ky}`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            if (res_data && res_data.length > 0) {
              this.ttlDstncCnt = res["data"];
              // console.log(this.ttlDstncCnt)
            }
          }
          this.stopLoading();
        },
        (err) => {
          this.stopLoading();
          // console.log(err);
        }
      );
  }

  gotoback() {
    this.route.navigate([`internal/dashboard/urban-dashboard`]);
    this.button_in = false;
  }

  get_totalTripsCount(funDt?, slctTnt?): any {
    this.ttlTrpsCnt = [];
    this.startLoading();
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 1,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/ttlTrips/${this.dbrd_ky}`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          var res_data = res["data"];
          if (res_data && res_data.length > 0) {
            this.ttlTrpsCnt = res["data"];
          }
          this.stopLoading();
        },
        (err) => {
          this.stopLoading();
          // console.log(err);
        }
      );
  }

  get_prmryTripsCount(funDt?, slctTnt?): any {
    this.prmryTrpsCnt = [];
    this.startLoading();
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 1,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/get_prmryTrips`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          var res_data = res["data"];
          // console.log(res_data);
          if (res_data && res_data.length > 0) {
            this.prmryTrpsCnt = res["data"];
            // console.log(this.prmryTrpsCnt);
            this.shwzrwErr = false;
          } else {
            this.shwzrwErr = true;
          }
          this.stopLoading();
        },
        (err) => {
          this.stopLoading();
          // console.log(err);
        }
      );
  }

  get_scndryTripsCount(funDt?, slctTnt?): any {
    this.scndryTrpsCnt = [];
    this.startLoading();
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 1,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/get_scndryTrips`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          var res_data = res["data"];
          if (res_data && res_data.length > 0) {
            this.scndryTrpsCnt = res["data"];
            // console.log(this.scndryTrpsCnt);
            this.shwScndryzrwErr = false;
          } else {
            this.shwScndryzrwErr = true;
          }
          this.stopLoading();
        },
        (err) => {
          this.stopLoading();
          // console.log(err);
        }
      );
  }
  // lst7DayDstnc;
  get_lst7DaysDistanceDta(funDt?, slctTnt?): any {
    // Check if chart container exists in DOM
    if (!document.getElementById("distanceTavelledChart")) {
      return;
    }
    // Dispose existing chart if it exists
    if (this.chart) {
      this.chart.dispose();
    }
    let chart = am4core.create("distanceTavelledChart", am4charts.XYChart);
    this.chart = chart;
    chart.data = [];
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 1,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/get_last7daydata/${this.dbrd_ky}`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          chart.data = res["data"] || [];
          this.ttl_vhcls = chart.data.length ? chart.data[0].ttl : 0;

          let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
          categoryAxis.dataFields.category = "dt";
          categoryAxis.renderer.grid.template.location = 0;
          categoryAxis.renderer.minGridDistance = 30;
          categoryAxis.title.text = ` ----- Date(${this.curYr})----- `;
          // categoryAxis.renderer.labels.template.rotation = -45;

          let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          // valueAxis.renderer.opposite = true;
          // valueAxis.strictMinMax = true;
          valueAxis.title.text = " ----- Vehicles ----- ";
          chart.colors.list = [
            am4core.color("#10b981"), // Modern green for Operated
            am4core.color("#ef4444"), // Modern red for Not Operated
          ];

          function createSeries(field, name, color) {
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = field;
            series.dataFields.categoryX = "dt";
            series.name = name;
            series.columns.template.tooltipText =
              "{name} on {categoryX}: [bold]{valueY} Vehicles[/]";
            series.columns.template.fillOpacity = 0.85;
            series.columns.template.fill = am4core.color(color);
            series.columns.template.stroke = am4core.color(color);
            series.columns.template.strokeWidth = 2;
            series.columns.template.height = am4core.percent(100);
            series.sequencedInterpolation = false;

            let columnTemplate1 = series.columns.template;
            columnTemplate1.strokeWidth = 2;

            // Add value label on top of each bar
            let valueLabel = series.bullets.push(new am4charts.LabelBullet());
            valueLabel.label.text = "{valueY}";
            valueLabel.label.fontSize = 11;
            valueLabel.label.fontWeight = "700";
            valueLabel.label.fill = am4core.color("#333333"); // Dark text for visibility
            valueLabel.label.dy = -12; // Position above the bar
            valueLabel.label.truncate = false;
            valueLabel.label.hideOversized = false;

            // Add a background to the label for better visibility
            valueLabel.label.background.fill = am4core.color("#ffffff");
            valueLabel.label.background.fillOpacity = 0.8;
            valueLabel.label.padding(2, 4, 2, 4);

            columnTemplate1.column.cornerRadiusTopLeft = 6;
            columnTemplate1.column.cornerRadiusTopRight = 6;
            columnTemplate1.strokeOpacity = 1;
          }

          // Always show operational status data with modern colors
          createSeries("oprtd", "Operated", "#10b981"); // Emerald green
          createSeries("nt_optrd", "Not Operated", "#ef4444"); // Red
        },
        (err) => {
          this.ttl_vhcls = 0;
        }
      );
  }
  // lst7DayTrps;
  get_lst7DaysTrpsDta(funDt?, slctTnt?): any {
    // Check if chart container exists in DOM
    if (!document.getElementById("ctgrytripsTavelledChart")) {
      return;
    }
    // Dispose existing charts if they exist
    if (this.chart2) {
      this.chart2.dispose();
    }
    let chart2 = am4core.create("ctgrytripsTavelledChart", am4charts.XYChart);
    this.chart2 = chart2;

    this.slctdDt = funDt;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 1,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/get_lst7DaysTrips`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        chart2.data = res["data"].results;
        if (res["data"].msg == 0) {
          this.nodata = true;
          this.nodataMsg = "No trips defined for the vehicle(s)";
        } else {
          this.nodata = false;
          this.nodataMsg = "";
        }
        let categoryAxis2 = chart2.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis2.dataFields.category = "dt";
        categoryAxis2.renderer.grid.template.location = 0;
        categoryAxis2.renderer.minGridDistance = 10;
        categoryAxis2.title.text = ` ----- Date (${this.curYr}) ----- `;
        // categoryAxis2.renderer.labels.template.rotation = -45;

        let valueAxis2 = chart2.yAxes.push(new am4charts.ValueAxis());
        // valueAxis2.renderer.inside = true;
        // valueAxis2.renderer.labels.template.disabled = true;
        // valueAxis2.min = 0;
        valueAxis2.title.text = " -----  Trips % ----- ";

        // Set modern color scheme for trips chart
        chart2.colors.list = [
          am4core.color("#3b82f6"), // Modern blue
          am4core.color("#8b5cf6"), // Purple
          am4core.color("#06b6d4"), // Cyan
          am4core.color("#f59e0b"), // Amber
        ];

        // Create series
        function createSeries(field, name, color) {
          // Set up series
          let series2 = chart2.series.push(new am4charts.ColumnSeries());
          series2.name = name;
          series2.dataFields.valueY = field;
          series2.dataFields.categoryX = "dt";
          series2.sequencedInterpolation = true;

          // Make it stacked
          series2.stacked = true;

          // Configure columns with modern styling
          series2.columns.template.width = am4core.percent(60);
          series2.columns.template.tooltipText =
            "[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}%";
          series2.columns.template.fillOpacity = 0.85;
          series2.columns.template.strokeWidth = 2;
          series2.columns.template.stroke = am4core.color(color);
          series2.columns.template.fill = am4core.color(color);

          // Add label with better styling
          let labelBullet = series2.bullets.push(new am4charts.LabelBullet());
          labelBullet.label.text = "{valueY}%";
          labelBullet.locationY = 0.5;
          labelBullet.label.hideOversized = true;
          labelBullet.label.fontSize = 11;
          labelBullet.label.fontWeight = "600";
          labelBullet.label.fill = am4core.color("#ffffff");

          return series2;
        }

        // createSeries('tot_trps', 'Total Trips');
        // createSeries('prmry_trps', 'Primary');
        // createSeries('scndry_trps', 'Secondary');
        // createSeries('othr_trps', 'Others');
        createSeries("trvl_per", "Travelled %", "#3b82f6"); // Modern blue
        // createSeries('fogAts_trps', 'Fog-Autos');
        // createSeries('swpngMchns_trps', 'Sweeping Machines');
        // Legend
        // chart2.legend = new am4charts.Legend();
      });
  }
  // lst10DaystrpsDta;
  get_lst10Days_ntOprdTrpsDta(funDt?, slctTnt?): any {
    if (this.chart5) {
      this.chart5.dispose();
    }
    let chart5 = am4core.create("lst10DysNtoprdTrpsChart", am4charts.XYChart);
    this.chart5 = chart5;
    chart5.data = [];
    this.slctdDt = funDt;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 1,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/get_lst10DaysNtOprdTrips`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        chart5.data = res["data"];

        let categoryAxis5 = chart5.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis5.dataFields.category = "dt";
        categoryAxis5.renderer.grid.template.location = 0;
        categoryAxis5.renderer.minGridDistance = 30;
        categoryAxis5.title.text = ` ----- Date(${this.curYr})----- `;
        // categoryAxis5.renderer.labels.template.rotation = -45;

        let valueAxis5 = chart5.yAxes.push(new am4charts.ValueAxis());
        valueAxis5.title.text = " ----- Trips ----- ";

        // Create series
        let series5 = chart5.series.push(new am4charts.ColumnSeries());
        series5.dataFields.valueY = "trps";
        series5.dataFields.categoryX = "dt";
        series5.name = "Category";
        series5.columns.template.tooltipText =
          "Not-operated in {categoryX}: [bold]{valueY}[/]";
        series5.columns.template.fillOpacity = 0.8;
        series5.columns.template.fill = am4core.color("#a573f2");
        series5.columns.template.stroke = am4core.color("#c7adefb0");
        let columnTemplate5 = series5.columns.template;
        columnTemplate5.strokeWidth = 1;
        let valueLabel = series5.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = "{trps}";
        valueLabel.label.fontSize = 15;

        // columnTemplate5.width = 60;
        columnTemplate5.column.cornerRadiusTopLeft = 5;
        columnTemplate5.column.cornerRadiusTopRight = 5;
        columnTemplate5.strokeOpacity = 1;
      });
  }

  get_routeDvtdTripsDetails(funDt?, slctTnt?): any {
    this.rtDvtdTripsDta = [];
    this.startLoading();
    this.slctdDt = funDt;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.postslctdDt = {
      dt: this.curDate,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/get_routeDvtdTrips`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            if (res_data && res_data.length > 0) {
              this.rtDvtdTripsDta = res["data"];
              if (this.clap_in == 1) {
                this.rtDvtdTripscolumnDefs = [
                  {
                    headerName: "S.No",
                    field: "sno",
                    alignment: "center",
                    width: 80,
                    filter: false,
                    search: false,
                  },
                  {
                    headerName: "ULB",
                    field: "tnt_nm",
                    alignment: "left",
                    width: 140,
                  },
                  {
                    headerName: "Vehicle Registration Number",
                    alignment: "left",
                    width: 130,
                    field: "asrt_nm",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "Vendor Name",
                    field: "vndr_nm",
                    alignment: "left",
                    width: "auto",
                  },
                  {
                    headerName: "Trip No.",
                    field: "trp_sqnc_nu",
                    width: 130,
                    alignment: "center",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "From",
                    alignment: "left",
                    width: 130,
                    field: "sch_strt_dt",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "To",
                    field: "sch_end_dt",
                    width: 130,
                    alignment: "left",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "Route Name",
                    field: "rte_nm",
                    width: 300,
                    alignment: "left",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "Distance",
                    alignment: "center",
                    width: 100,
                    field: "dst",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "Travel Hours",
                    field: "trvl_hr",
                    width: 100,
                    alignment: "center",
                    cellClass: "pm-grid-number-cell",
                  },
                ];
              } else {
                this.rtDvtdTripscolumnDefs = [
                  {
                    headerName: "S.No",
                    field: "sno",
                    alignment: "center",
                    width: 80,
                    filter: false,
                    search: false,
                  },
                  {
                    headerName: "ULB",
                    field: "tnt_nm",
                    alignment: "left",
                    width: 140,
                  },
                  {
                    headerName: "Vehicle Registration Number",
                    alignment: "left",
                    width: 130,
                    field: "asrt_nm",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "Vehicle Category",
                    alignment: "left",
                    width: 130,
                    field: "asrt_ctgry_nm",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "Trip No.",
                    field: "trp_sqnc_nu",
                    width: 130,
                    alignment: "center",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "From",
                    alignment: "left",
                    width: 130,
                    field: "sch_strt_dt",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "To",
                    field: "sch_end_dt",
                    width: 130,
                    alignment: "left",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "Route Name",
                    field: "rte_nm",
                    width: 300,
                    alignment: "left",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "Distance",
                    alignment: "center",
                    width: 100,
                    field: "dst",
                    cellClass: "pm-grid-number-cell",
                  },
                  {
                    headerName: "Travel Hours",
                    field: "trvl_hr",
                    width: 100,
                    alignment: "center",
                    cellClass: "pm-grid-number-cell",
                  },
                ];
              }
            }
          }
          this.stopLoading(); // must run for every response, not just status 200
        },
        (err) => {
          this.stopLoading();
        }
      );
  }
  get_Trips_trvalledDetails(funDt?, slctTnt?): any {
    // Data is swapped in on response rather than blanked first — see
    // getVehicleswiseData() for why.
    this.startLoading();
    this.slctdDt = funDt;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.postslctdDt = {
      dt: this.curDate,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/get_tdyTripDetails`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            // console.log(res_data)
            if (!res_data || res_data.length === 0) {
              this.tripsTrvldDta = [];
              this.tripsTrvldDtaDup = [];
              this.updateTripsCounts();
            }
            if (res_data && res_data.length > 0) {
              this.tripsTrvldDtaDup = res["data"];
              this.tripsTrvldDta = res["data"];
              this.updateTripsCounts(); // Update cached trips counts
              this.sortedTrvlData("all");
              // if (this.clap_in == 1) {
              //   this.tripsTrvldcolumnDefs = [
              //     { headerName: 'S.No', field: 'sno', alignment: 'center', width: 80, filter: false, search: false },
              //     { headerName: 'ULB', field: 'tnt_nm', alignment: 'left', width: 120 },
              //     { headerName: 'Vehicle registration Number', alignment: 'left', width: 120, field: 'asrt_nm' },
              //     { headerName: 'Vendor Name', field: 'vndr_nm', alignment: 'left', width: 'auto' },
              //     { headerName: 'Trip No.', field: 'trp_sqnc_nu', alignment: 'center', width: 'auto' },
              //     { headerName: 'Trip Type', field: 'trp_typ_nm', alignment: 'center', filter: true, width: 90 },
              //     { headerName: 'From', alignment: 'center', field: 'strt_fnce_nm', width: 220 },
              //     { headerName: 'To', field: 'end_fnce_nm', alignment: 'center', width: 220 },
              //     { headerName: 'Actual Start', alignment: 'center', field: 'actl_strt_ts', width: 150 },
              //     { headerName: 'Actual End', field: 'actl_end_ts', alignment: 'center', width: 150 },
              //     { headerName: 'Trip Status', field: 'trp_status', alignment: 'center', width: 90 },
              //     { headerName: 'Travelled Distance', alignment: 'center', field: 'actl_trvl_dstne_ct', width: 'auto' },
              //     { headerName: 'Travelled Time', field: 'actl_trvl_tm', alignment: 'center', width: 'auto' },
              //     { headerName: 'Route Deviation', field: 'rt_dev', alignment: 'center', width: 'auto' },
              //     // { headerName: 'Lat', field: 'lat', alignment: 'center', width: 'auto' },
              //     // { headerName: 'lng', alignment: 'center', field: 'lng', width: 'auto' },
              //     // { headerName: 'Vehicle Category', field: 'asrt_ctgry_nm', alignment: 'center', width: 'auto' },
              //     // { headerName: 'Vehicle Group', field: 'asrt_grp_nm', alignment: 'center', width: 'auto' },
              //   ]
              // } else {
              //   this.tripsTrvldcolumnDefs = [
              //     { headerName: 'S.No', field: 'sno', alignment: 'center', width: 80, filter: false, search: false },
              //     { headerName: 'ULB', field: 'tnt_nm', alignment: 'left', width: 140 },
              //     { headerName: 'Vehicle registration Number', alignment: 'left', width: 130, field: 'asrt_nm', cellClass: 'pm-grid-number-cell' },
              //     { headerName: 'Vehicle Category', alignment: 'left', field: 'asrt_ctgry_nm', cellClass: 'pm-grid-number-cell' },
              //     { headerName: 'Vehicle Group', field: 'asrt_grp_nm', alignment: 'center', cellClass: 'pm-grid-number-cell' },
              //     { headerName: 'Trip No.', field: 'trp_sqnc_nu', alignment: 'center', width: 'auto' },
              //     { headerName: 'Trip Type', field: 'trp_typ_nm', alignment: 'center', filter: true, width: 90 },
              //     { headerName: 'From', alignment: 'center', field: 'strt_fnce_nm', width: 220 },
              //     { headerName: 'To', field: 'end_fnce_nm', alignment: 'center', width: 220 },
              //     { headerName: 'Actual Start', alignment: 'center', field: 'actl_strt_ts', width: 150 },
              //     { headerName: 'Actual End', field: 'actl_end_ts', alignment: 'center', width: 150 },
              //     { headerName: 'Trip Status', field: 'trp_status', alignment: 'center', width: 90 },
              //     { headerName: 'Travelled Distance', alignment: 'center', field: 'actl_trvl_dstne_ct', width: 'auto' },
              //     { headerName: 'Travelled Time', field: 'actl_trvl_tm', alignment: 'center', width: 'auto' },
              //     { headerName: 'Route Deviation', field: 'rt_dev', alignment: 'center', width: 'auto' },
              //     // { headerName: 'Lat', field: 'lat', alignment: 'center', width: 'auto' },
              //     // { headerName: 'lng', alignment: 'center', field: 'lng', width: 'auto' },
              //     // { headerName: 'Vehicle Category', field: 'asrt_ctgry_nm', alignment: 'center', cellClass: 'pm-grid-number-cell' },
              //   ]
              // }
            }
          }
          this.stopLoading(); // must run for every response, not just status 200
        },
        (err) => {
          this.stopLoading();
        }
      );
  }

  // get_wrkrsLstDetails(funDt?, slctTnt?): any {
  //   this.swprsWrkngTmDta = [];
  //   this.showLdr = true;
  //   this.slctdDt = funDt;
  //   this.curDate = moment(this.slctdDt).format('YYYY-MM-DD');
  //   this.postslctdDt = {
  //     dt: this.curDate,
  //     slctd_tnt: slctTnt
  //   }
  //   let rte = `dashboard/enterprise/get_wrkrsLst`;
  //   this.apiServ.post(this.postslctdDt, rte).subscribe((res) => {
  //     if (res['status'] == 200) {
  //       var res_data = res['data'];
  //       if (res_data && res_data.length > 0) {
  //         this.swprsWrkngTmDta = res['data'];
  //         this.swprsWrkngTmcolumnDefs = [
  //           { headerName: 'S.No', field: 'sno', alignment: 'center', width: 80, filter: false, search: false },
  //           { headerName: 'ULB', field: 'tnt_nm', alignment: 'left', width: 140 },
  //           { headerName: 'Vehicle Name', alignment: 'center', width: 160, field: 'asrt_nm', cellClass: 'pm-grid-number-cell' },
  //           { headerName: 'Date', field: 'dt', width: 120, alignment: 'center', cellClass: 'pm-grid-number-cell' },
  //           { headerName: 'No.of hours worked', field: 'hrs', width: 120, alignment: 'center', cellClass: 'pm-grid-number-cell' },
  //           { headerName: 'Total Distance', field: 'max_dst_ct', width: 120, alignment: 'center', cellClass: 'pm-grid-number-cell' },
  //           { headerName: 'Travelled Distance', field: 'dstnc', width: 120, alignment: 'center', cellClass: 'pm-grid-number-cell' }
  //         ]
  //       }
  //       this.showLdr = false;
  //     }
  //   }, (err) => {
  //     // console.log(err);
  //   });
  // }

  // Add data

  gotoPlaybck(event) {
    let tripData;
    if (event && event.row && event.row.data) {
      tripData = event.row.data;
    } else if (event && event.data) {
      tripData = event.data;
    }

    if (tripData) {
      // console.log('event: ', tripData);
      // Store trip data for tracking component
      this.TransfereService.setLoclData("plybckDta", tripData);
      if (tripData.actl_strt != undefined && tripData.actl_end != undefined) {
        // Navigate to tracking page instead of play-back page
        this.route.navigate([`internal/tracking/list`]);
      } else {
        this.message.create("error", "Trip data is not available for playback");
      }
    }
  }
  onCellPrepared(colDef, e) {
    if (e.rowType === "data" && e.row.data) {
      // Check if this is the trips table by comparing column definitions
      const isTripsTable =
        colDef && Array.isArray(colDef) && colDef === this.tripsTrvldcolumnDefs;

      // Highlight vehicle column for trips table
      if (
        isTripsTable &&
        (e.column.dataField === "asrt_nm" ||
          e.column.dataField === "Vehicle registration Number")
      ) {
        e.cellElement.style.color = "#2563eb";
        e.cellElement.style.fontWeight = 600;
        e.cellElement.style.cursor = "pointer";
        e.cellElement.style.textDecoration = "underline";
        e.cellElement.title = "Click to view vehicle dashboard";
      }

      // Highlight driver column for trips table
      if (
        isTripsTable &&
        (e.column.dataField === "crw_nm" ||
          e.column.dataField === "Driver Name")
      ) {
        e.cellElement.style.color = "#2563eb";
        e.cellElement.style.fontWeight = 600;
        e.cellElement.style.cursor = "pointer";
        e.cellElement.style.textDecoration = "underline";
        e.cellElement.title = "Click to view driver dashboard";
      }

      // Legacy support for 'Vehicle No' field
      if (e.column.dataField == "Vehicle No") {
        e.cellElement.style.color = "#ff0000";
        e.cellElement.style.fontWeight = 500;
        e.cellElement.style.borderRadius = "10px";
        e.cellElement.style.background =
          "rgba(243, 191, 176, 0.2784313725490196)";
        e.cellElement.style.backgroundClip = "content-box";
        e.cellElement.style.cursor = "pointer";
      }
    }
  }

  /**
   * Navigate to vehicle dashboard
   */
  navigateToVehicleDashboard(rowData: any): void {
    if (rowData && rowData.asrt_id) {
      // Store vehicle data for vehicle slider
      this.selectedVehicle = rowData;
      this.visible = true;
    }
  }

  /**
   * Handle cell click in trips table
   */
  onTripsCellClick(e: any): void {
    if (e && e.column && e.data) {
      const columnField = e.column.dataField;
      // Check if clicked column is vehicle column
      if (
        columnField === "asrt_nm" ||
        columnField === "Vehicle registration Number"
      ) {
        e.event.stopPropagation();
        this.navigateToVehicleDashboard(e.data);
      }
      // Check if clicked column is driver column
      if (columnField === "crw_nm" || columnField === "Driver Name") {
        e.event.stopPropagation();
        this.route.navigate(["/internal/dashboard/driver-dashboard"], {
          queryParams: {
            crw_id: JSON.stringify(e.data.crw_id),
            tnt_id: JSON.stringify(e.data.tnt_id),
          },
        });
      }
    }
  }

  // Handle cell click for vehicles table
  onVehiclesCellClick(e: any): void {
    if (e && e.column && e.data) {
      const columnField = e.column.dataField;
      /* Vehicle-name click — open the in-page vehicle slider drawer
         (top of the template, [nzVisible]="visible" with <app-vehicle-slider>).
         Was navigating to /internal/dashboard/vehicle-dashboard which took
         the user AWAY from the ULB dashboard; now stays on-page. Same
         pattern as getVehDashSldr() above and the trips-table cell click. */
      if (columnField === "asrt_nm" || columnField === "Vehicle Number") {
        this.selectedVehicle = e.data;
        this.visible = true;
      }
      /* Driver-name click — open the in-page driver slider drawer
         ([nzVisible]="driverSldrVisible" with <app-driver-slider>). Was
         navigating to /internal/dashboard/driver-dashboard; now uses the
         existing openDriverSlider(data) helper which sets both
         selectedDriverForSlider and driverSldrVisible. */
      if (columnField === "crw_nm" || columnField === "Driver Name") {
        this.openDriverSlider(e.data);
      }
    }
  }

  // Open driver slider
  openDriverSlider(data: any): void {
    if (data && data.crw_id) {
      this.selectedDriverForSlider = data;
      this.driverSldrVisible = true;
    }
  }

  // Close driver slider
  closeDriverSlider(): void {
    this.driverSldrVisible = false;
    this.selectedDriverForSlider = null;
  }

  // Highlight clickable cells in vehicles table
  onVehiclesTableCellPrepared(e: any): void {
    if (e.rowType === "data" && e.row.data) {
      const columnField = e.column.dataField;
      // Highlight vehicle column
      if (columnField === "asrt_nm" || columnField === "Vehicle Number") {
        e.cellElement.style.color = "#2563eb";
        e.cellElement.style.fontWeight = "600";
        e.cellElement.style.cursor = "pointer";
        e.cellElement.style.textDecoration = "underline";
        // Tooltip now reflects the new behaviour — opens the slider drawer
        // in-page instead of navigating to /vehicle-dashboard.
        e.cellElement.title = "Click to open vehicle details";
      }
      // Highlight driver column
      if (columnField === "crw_nm" || columnField === "Driver Name") {
        e.cellElement.style.color = "#2563eb";
        e.cellElement.style.fontWeight = "600";
        e.cellElement.style.cursor = "pointer";
        e.cellElement.style.textDecoration = "underline";
        // Tooltip now reflects the new behaviour — opens the driver slider
        // drawer in-page instead of navigating to /driver-dashboard.
        e.cellElement.title = "Click to open driver profile";
      }
    }
  }

  get_ctgrywisecounts(funDt?, slctTnt?): any {
    this.ctgryWseCnts = [];
    this.startLoading();
    this.slctdDt = funDt;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.curTmspDate = moment(this.slctdDt).format("YYYY-MM-DD HH:mm:ss");
    this.postslctdDt = {
      dt: this.curDate,
      dtsp: this.curTmspDate,
      tnt_in: 1,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/get_ctgryWiseCnts`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            if (res_data && res_data.length > 0) {
              this.ctgryWseCnts = res["data"];
            }
          }
          this.stopLoading(); // must run for every response, not just status 200
        },
        (err) => {
          this.stopLoading();
        }
      );
  }

  scroll(id) {
    // this.vps.scrollToAnchor(id);
  }
  get_SolidwasteTripsCount(funDt?): any {
    this.startLoading();
    this.ctgryWseCnts = [];
    this.slctdDt = funDt;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.curTmspDate = moment(this.slctdDt).format("YYYY-MM-DD HH:mm:ss");
    this.postslctdDt = {
      dt: this.curDate,
      dtsp: this.curTmspDate,
      tnt_in: 1,
      tnt_f_id: this.selectedtenant,
    };

    const rte = `dashboard/enterprise/get_solidwaste_CvrgDta`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.cvrgDta = res["data"];
          if (this.cvrgDta && this.cvrgDta.length > 0) {
            for (let i = 0; i < this.cvrgDta.length; i++) {
              if (this.cvrgDta[i].fnce_grp_id == 1000012) {
                this.trnsfrPnts = this.cvrgDta[i];
              } else if (this.cvrgDta[i].fnce_grp_id == 1000013) {
                this.trnsfrStns = this.cvrgDta[i];
              } else if (this.cvrgDta[i].fnce_grp_id == 1000015) {
                this.mrfPnts = this.cvrgDta[i];
              } else if (this.cvrgDta[i].fnce_grp_id == 1000020) {
                this.prcngPnts = this.cvrgDta[i];
              }
            }
          }
          this.stopLoading(); // must run even when the response has no rows
        },
        (err) => {
          this.stopLoading();
        }
      );
  }
  get_HousesTripsCount(): any {
    this.startLoading();
    const rte = `dashboard/enterprise/get_houses_CvrgDta/${this.ulb_id}`;
    this.apiServ
      .get(rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["data"] && res["data"].length > 0) {
            this.HsDta = res["data"][0];
          }
          this.stopLoading();
        },
        (err) => {
          this.stopLoading();
        }
      );
  }
  getDtls(dta, cd) {
    this.startLoading();
    this.postCntdata = {
      grp_dta: dta,
      typ: cd,
    };
    let rte = `dashboard/enterprise/get_solidwaste_CntDta`;
    this.apiServ
      .post(this.postCntdata, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            if (res_data && res_data.length > 0) {
              this.cnt_dtls = res_data;
              this.cnt_dtlscolumnDefs = [
                {
                  headerName: "S.No",
                  field: "sno",
                  alignment: "center",
                  width: 80,
                  filter: false,
                },
                {
                  headerName: "ULB",
                  field: "tnt_nm",
                  alignment: "left",
                  width: 140,
                },
                {
                  headerName: "Fence Group",
                  alignment: "center",
                  width: 200,
                  field: "fnce_grp_nm",
                },
                {
                  headerName: "Fence Category",
                  alignment: "center",
                  width: 200,
                  field: "fnce_ctgry_nm",
                },
                {
                  headerName: "Fence",
                  alignment: "center",
                  width: 200,
                  field: "fnce_nm",
                },
                {
                  headerName: "In Time",
                  alignment: "center",
                  width: 200,
                  field: "in_tm",
                },
                {
                  headerName: "Out Time",
                  alignment: "center",
                  width: 200,
                  field: "ot_tm",
                },
                {
                  headerName: "Status",
                  alignment: "center",
                  width: 200,
                  field: "sts",
                },
              ];
            }
          }
          this.stopLoading(); // must run for every response, not just status 200
        },
        (err) => {
          this.stopLoading();
        }
      );
  }
  getVehiclesOperatedcntsVndrULBwise(funDt?, slctTnt?) {
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/getVehicle_oprtnl_sts`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          let res_data = res["data"];
          if (res_data && res_data.length > 0) {
            this.VndrwseopratedvehclesTble = res["data"];
            // let counter = 0;
            //   this.ulbVndrwseopratedTripsTble.filter((k) => {
            //     k['sno'] = ++counter;
            //   });
            this.VndrwseopratedvehclesTblecolumnDefs = [
              {
                headerName: "S.No",
                field: "sno",
                alignment: "center",
                width: 60,
                filter: false,
              },
              {
                headerName: "Vehicle Number",
                field: "asrt_nm",
                alignment: "left",
                width: 90,
              },
              {
                headerName: "Ward",
                field: "wrd_nm",
                alignment: "left",
                width: 140,
              },
              {
                headerName: "Operational Status",
                field: "opr_sts",
                width: 90,
                alignment: "left",
              },
              {
                headerName: "Assigned Trips",
                field: "asgnd_trps",
                width: 90,
                alignment: "left",
              },
              {
                headerName: "Travelled Trips",
                field: "trvl_trps",
                width: 90,
                alignment: "left",
              },
              {
                headerName: "Travelled Distance",
                field: "trvl_dst",
                width: 90,
                alignment: "left",
              },
            ];
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }
  getVehicleswiseData(funDt?, slctTnt?) {
    this.slctdDt = funDt;
    // Grid data is swapped in on response instead of being blanked first, so
    // the table does not empty-then-refill (a flash) on every refresh.
    this.startLoading();
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      slctd_tnt: slctTnt,
    };
    let rte = `dashboard/enterprise/getVehicleSts`;
    this.apiServ
      .post(this.postslctdDt, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          let res_data = res["data"];
          if (!res_data || res_data.length === 0) {
            this.vehclesTble = [];
            this.vehclesTbleDup = [];
            this.updateOperationalCounts();
            this.calculateTopLeast10Vehicles();
          }
          if (res_data && res_data.length > 0) {
            this.vehclesTbleDup = res["data"];
            // Compute display fields for each vehicle
            this.vehclesTbleDup.forEach((v: any) => {
              v.igntn_dsply = v.igntn_in == 1 ? "Yes" : "No";
              v.vhcl_type_nm =
                v.trp_type_id == 1
                  ? "Primary"
                  : v.trp_type_id == 2
                  ? "Secondary"
                  : "-";
              v.opr_sts_nm = v.opr_in == 1 ? "Operated" : "Not Operated";
            });
            this.vehclesTble = this.vehclesTbleDup;
            this.updateOperationalCounts(); // Update cached counts for operational status
            this.calculateTopLeast10Vehicles(); // Compute top/least 10 operated vehicles
            this.sortedVehData("all");
            // if (this.clntDtls[0].clnt_id == 7 && this.clap_in == 1) {
            //   this.vehclesTblecolumnDefs = [
            //     { headerName: 'S.No', field: 'sno', alignment: 'center', width: 50, filter: false },
            //     { headerName: 'District', field: 'dstrct_nm', alignment: 'left', width: 100 },
            //     { headerName: 'ULB', field: 'tnt_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Vehicle Number', field: 'asrt_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'IMEI', field: 'dev_imei_nu', alignment: 'left', width: 'auto' },
            //     { headerName: 'Vendor Name', field: 'vndr_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Sachivalayam', field: 'svm_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Sachivalayam Code', field: 'svm_apfs_cd', alignment: 'left', width: 'auto' },
            //     { headerName: 'Driver Name', field: 'crw_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Driver Contact', field: 'crw_ph', alignment: 'left', width: 'auto' },
            //     { headerName: 'Sanitary Secratory', field: 'ss_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Sanitary Secratory Contact', field: 'ss_cntct', alignment: 'left', width: 'auto' },
            //     { headerName: 'Assigned Trips', field: 'asgnd_trps', alignment: 'center' },
            //     { headerName: 'Today Travelled Trips', field: 'tdy_trvl_trps', alignment: 'center', width: 'auto' },
            //     // { headerName: 'Yesterday Travelled Trips', field: 'yst_dy_trvl_trps', alignment: 'center' },
            //     { headerName: 'Today Travelled Distance in Kms', field: 'tdy_trvl_dst', alignment: 'center', width: 'auto' },
            //     // { headerName: 'Yesterday Travelled Distance in Kms', field: 'yst_dy_trvl_dst',  alignment: 'center' },
            //   ]
            // } else if (this.clntDtls[0].clnt_id != 7) {
            //   this.vehclesTblecolumnDefs = [
            //     { headerName: 'S.No', field: 'sno', alignment: 'center', width: 50, filter: false },
            //     { headerName: 'ULB', field: 'tnt_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Vehicle Number', field: 'asrt_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'IMEI', field: 'dev_imei_nu', alignment: 'left', width: 'auto' },
            //     { headerName: 'Vendor Name', field: 'vndr_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Driver Name', field: 'crw_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Driver Contact', field: 'crw_ph', alignment: 'left', width: 'auto' },
            //     // { headerName: 'Sanitary Secratory', field: 'ss_nm', alignment: 'left', width: 'auto' },
            //     // { headerName: 'Sanitary Secratory Contact', field: 'ss_cntct', alignment: 'left', width: 'auto' },
            //     { headerName: 'Assigned Trips', field: 'asgnd_trps', alignment: 'center', width: 'auto' },
            //     { headerName: 'Today Travelled Trips', field: 'tdy_trvl_trps', alignment: 'center', width: 'auto' },
            //     { headerName: 'Today Travelled Distance in Kms', field: 'tdy_trvl_dst', alignment: 'center', width: 'auto' },
            //   ]
            // }
            // else {
            //   this.vehclesTblecolumnDefs = [
            //     { headerName: 'S.No', field: 'sno', alignment: 'center', width: 50, filter: false },
            //     { headerName: 'ULB', field: 'tnt_nm', alignment: 'left', width: 100 },
            //     { headerName: 'Vehicle Number', field: 'asrt_nm', alignment: 'left', width: 180 },
            //     { headerName: 'IMEI', field: 'dev_imei_nu', alignment: 'left', width: 'auto' },
            //     { headerName: 'Vehicle Category', field: 'asrt_ctgry_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Sachivalayam', field: 'svm_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Sachivalayam Code', field: 'svm_apfs_cd', alignment: 'left', width: 'auto' },
            //     { headerName: 'Driver Name', field: 'crw_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Driver Contact', field: 'crw_ph', alignment: 'left', width: 'auto' },
            //     { headerName: 'Sanitary Secratory', field: 'ss_nm', alignment: 'left', width: 'auto' },
            //     { headerName: 'Sanitary Secratory Contact', field: 'ss_cntct', alignment: 'left', width: 'auto' },
            //     { headerName: 'Assigned Trips', field: 'asgnd_trps', alignment: 'center', width: 'auto' },
            //     { headerName: 'Today Travelled Trips', field: 'tdy_trvl_trps', alignment: 'center', width: 'auto' },
            //     { headerName: 'Today Travelled Distance in Kms', field: 'tdy_trvl_dst', alignment: 'center', width: 'auto' },
            //   ]
            // }
          }
          this.stopLoading();
        },
        (err) => {
          this.stopLoading();
          // console.log(err);
        }
      );
  }

  downloadVehiclesPdf() {
    if (!this.canExportPdf) {
      this.message.create(
        "error",
        "Access denied. You do not have permission to download PDF reports."
      );
      return;
    }
    let head = [];
    let data = [];

    // Extract headers based on visible columns
    this.vehclesTblecolumnDefs.filter((c) => {
      if (!c.hide) {
        head.push(c.headerName);
      }
    });

    // Extract data rows mapping to the exact headers
    this.vehclesTble.filter((k) => {
      let row = [];
      this.vehclesTblecolumnDefs.filter((c) => {
        if (!c.hide) {
          row.push(k[`${c.field}`] || "-");
        }
      });
      data.push(row);
    });

    var pdfsize = "a4";
    var pageMode = "l";
    var reqfontSize = 8;

    var doc = new jsPDF(pageMode as any, "mm", pdfsize);

    var rpt_hdr_tx = "ULB Wise Vehicles Report";

    doc.setFontSize(reqfontSize);
    (doc as any).autoTable({
      head: [head],
      body: data,
      theme: "grid",
      didDrawPage: function (data) {
        doc.setFontSize(14);
        doc.setTextColor(40);
        doc.text(rpt_hdr_tx, data.settings.margin.left, 22);
      },
      margin: { top: 30 },
    });

    doc.save("Vehicles_Report.pdf");
  }

  // onExporting1()/onExporting2() removed with the <app-data-grid> conversion.
  // Both were the standard exportDataGrid({ customizeCell: sanitizeExcelCell })
  // block; DataGridComponent.exportExcel() now does it for every grid.

  sortedTrvlData(ky: string) {
    this.tripsTrvldDta = [];
    if (ky == "all") {
      this.trpsbHdr = "";
      this.tripsTrvldDta = [...this.tripsTrvldDtaDup];
    } else if (ky == "ttl") {
      this.trpsbHdr = "Defined";
      this.tripsTrvldDta = [...this.tripsTrvldDtaDup];
      this.scrollTrpsTbl();
    } else if (ky == "trvl") {
      this.trpsbHdr = "Travelled";
      this.tripsTrvldDta = this.tripsTrvldDtaDup.filter(
        (k: any) => k.trp_strt_in == 1 && k.trp_cls_in == 1
      );
      this.scrollTrpsTbl();
    } else if (ky == "nottrvl") {
      this.trpsbHdr = "Not Travelled";
      this.tripsTrvldDta = this.tripsTrvldDtaDup.filter(
        (k: any) => !(k.trp_strt_in == 1 && k.trp_cls_in == 1)
      );
      this.scrollTrpsTbl();
    }
    let counter = 0;
    this.tripsTrvldDta.filter((k: any) => {
      k["sno"] = ++counter;
    });
    if (this.clap_in == 1) {
      this.tripsTrvldcolumnDefs = [
        {
          headerName: "S.No",
          field: "sno",
          alignment: "center",
          width: 80,
          filter: false,
          search: false,
        },
        { headerName: "ULB", field: "tnt_nm", alignment: "left", width: 140 },
        {
          headerName: "Vehicle registration Number",
          alignment: "left",
          width: 180,
          field: "asrt_nm",
          cellTemplate: "tripsVehicleTemplate",
        },
        {
          headerName: "Driver Name",
          field: "crw_nm",
          alignment: "left",
          width: 150,
          cellTemplate: "tripsDriverTemplate",
        },
        // { headerName: 'Vendor Name', field: 'vndr_nm', alignment: 'left', width: 'auto' },
        {
          headerName: "Trip No.",
          field: "trp_sqnc_nu",
          alignment: "center",
          width: 100,
        },
        {
          headerName: "Trip Type",
          field: "trp_typ_nm",
          alignment: "center",
          filter: true,
          width: 120,
        },
        {
          headerName: "From",
          alignment: "center",
          field: "strt_fnce_nm",
          width: 200,
        },
        {
          headerName: "To",
          field: "end_fnce_nm",
          alignment: "center",
          width: 200,
        },
        {
          headerName: "Actual Start",
          alignment: "center",
          field: "actl_strt_ts",
          width: 150,
        },
        {
          headerName: "Actual End",
          field: "actl_end_ts",
          alignment: "center",
          width: 150,
        },
        {
          headerName: "Trip Status",
          field: "trp_status",
          alignment: "center",
          width: 120,
        },
        {
          headerName: "Travelled Distance",
          alignment: "center",
          field: "actl_trvl_dstne_ct",
          width: 150,
        },
        {
          headerName: "Travelled Time",
          field: "actl_trvl_tm",
          alignment: "center",
          width: 140,
        },
        {
          headerName: "Route Deviation",
          field: "rt_dev",
          alignment: "center",
          width: 140,
        },
        // { headerName: 'Lat', field: 'lat', alignment: 'center', width: 'auto' },
        // { headerName: 'lng', alignment: 'center', field: 'lng', width: 'auto' },
        // { headerName: 'Vehicle Category', field: 'asrt_ctgry_nm', alignment: 'center', width: 'auto' },
        // { headerName: 'Vehicle Group', field: 'asrt_grp_nm', alignment: 'center', width: 'auto' },
      ];
    } else {
      this.tripsTrvldcolumnDefs = [
        {
          headerName: "S.No",
          field: "sno",
          alignment: "center",
          width: 80,
          filter: false,
          search: false,
        },
        { headerName: "ULB", field: "tnt_nm", alignment: "left", width: 140 },
        {
          headerName: "Vehicle registration Number",
          alignment: "left",
          width: 180,
          field: "asrt_nm",
          cellClass: "pm-grid-number-cell",
          cellTemplate: "tripsVehicleTemplate",
        },
        {
          headerName: "Driver Name",
          field: "crw_nm",
          alignment: "left",
          width: 150,
          cellTemplate: "tripsDriverTemplate",
        },
        {
          headerName: "Vehicle Category",
          alignment: "left",
          field: "asrt_ctgry_nm",
          width: 150,
          cellClass: "pm-grid-number-cell",
        },
        {
          headerName: "Vehicle Group",
          field: "asrt_grp_nm",
          alignment: "center",
          width: 140,
          cellClass: "pm-grid-number-cell",
        },
        {
          headerName: "Trip No.",
          field: "trp_sqnc_nu",
          alignment: "center",
          width: 100,
        },
        {
          headerName: "Trip Type",
          field: "trp_typ_nm",
          alignment: "center",
          filter: true,
          width: 120,
        },
        {
          headerName: "From",
          alignment: "center",
          field: "strt_fnce_nm",
          width: 220,
        },
        {
          headerName: "To",
          field: "end_fnce_nm",
          alignment: "center",
          width: 220,
        },
        {
          headerName: "Actual Start",
          alignment: "center",
          field: "actl_strt_ts",
          width: 150,
        },
        {
          headerName: "Actual End",
          field: "actl_end_ts",
          alignment: "center",
          width: 150,
        },
        {
          headerName: "Trip Status",
          field: "trp_status",
          alignment: "center",
          width: 120,
        },
        {
          headerName: "Travelled Distance",
          alignment: "center",
          field: "actl_trvl_dstne_ct",
          width: 150,
        },
        {
          headerName: "Travelled Time",
          field: "actl_trvl_tm",
          alignment: "center",
          width: 140,
        },
        {
          headerName: "Route Deviation",
          field: "rt_dev",
          alignment: "center",
          width: 140,
        },
        // { headerName: 'Lat', field: 'lat', alignment: 'center', width: 'auto' },
        // { headerName: 'lng', alignment: 'center', field: 'lng', width: 'auto' },
        // { headerName: 'Vehicle Category', field: 'asrt_ctgry_nm', alignment: 'center', cellClass: 'pm-grid-number-cell' },
      ];
    }
    // The View/Playback column was declared in the TEMPLATE, as a standalone
    // <dxi-column type="buttons" caption="View" cellTemplate="editTemplate">
    // outside the *ngFor. <app-data-grid> takes all columns from one array, so
    // it is appended here - both branches above, hence outside the if/else.
    // Dropping it would have removed the Playback button with a green build.
    this.tripsTrvldcolumnDefs = [
      ...(this.tripsTrvldcolumnDefs || []),
      {
        headerName: "View",
        field: "__view",
        alignment: "center",
        width: 100,
        cellTemplate: "editTemplate",
        showInColumnChooser: false,
        filter: false,
      },
    ];
  }
  sortedVehData(ky: string) {
    if (ky == "all") {
      this.sbHdr = "";
      this.vehclesTble = this.vehclesTbleDup;
    } else if (ky == "act") {
      this.sbHdr = "Active ";
      this.vehclesTble = this.vehclesTbleDup.filter((k: any) => {
        return k.asrt_spre_in != 1;
      });
      this.timeoutHandles.push(setTimeout(() => this.scrollVehTbl(), 150));
    } else if (ky == "inact") {
      this.sbHdr = "Spare ";
      this.vehclesTble = this.vehclesTbleDup.filter((k: any) => {
        return k.asrt_spre_in == 1;
      });
      this.timeoutHandles.push(setTimeout(() => this.scrollVehTbl(), 150));
    } else if (ky == "oprtd") {
      this.sbHdr = "Operated ";
      this.vehclesTble = this.vehclesTbleDup.filter((k: any) => k.opr_in == 1);
      this.timeoutHandles.push(
        setTimeout(() => this.scrollOperationalTbl(), 150)
      );
    } else if (ky == "notoprtd") {
      this.sbHdr = "Not Operated ";
      this.vehclesTble = this.vehclesTbleDup.filter((k: any) => k.opr_in == 0);
      this.timeoutHandles.push(
        setTimeout(() => this.scrollOperationalTbl(), 150)
      );
    }

    let counter = 0;
    this.vehclesTble.filter((k) => {
      k["sno"] = ++counter;
    });
    if (this.clntDtls[0].clnt_id == 7 && this.clap_in == 1) {
      this.vehclesTblecolumnDefs = [
        {
          headerName: "S.No",
          field: "sno",
          alignment: "center",
          width: 100,
          filter: false,
        },
        {
          headerName: "District",
          field: "dstrct_nm",
          alignment: "left",
          width: 100,
        },
        {
          headerName: "ULB",
          field: "tnt_nm",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Vehicle Number",
          field: "asrt_nm",
          alignment: "left",
          width: "auto",
          cellTemplate: "vehicleTemplate",
        },
        {
          headerName: "Vehicle Category",
          field: "asrt_ctgry_nm",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Vehicle Type",
          field: "vhcl_type_nm",
          alignment: "center",
          width: 100,
        },
        {
          headerName: "Vehicle Status",
          field: "asrt_sts_nm",
          alignment: "center",
          width: 100,
          cellTemplate: "vehicleStatusTemplate",
        },
        {
          headerName: "Ignition",
          field: "igntn_dsply",
          alignment: "center",
          width: 100,
          cellTemplate: "ignitionTemplate",
        },
        {
          headerName: "Operational Status",
          field: "opr_sts_nm",
          alignment: "center",
          width: 120,
          cellTemplate: "operationalStatusTemplate",
        },
        {
          headerName: "IMEI",
          field: "dev_imei_nu",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Vendor Name",
          field: "vndr_nm",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Sachivalayam",
          field: "svm_nm",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Sachivalayam Code",
          field: "svm_apfs_cd",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Driver Name",
          field: "crw_nm",
          alignment: "left",
          width: "auto",
          cellTemplate: "driverTemplate",
        },
        {
          headerName: "Driver Contact",
          field: "crw_ph",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Sanitary Secratory",
          field: "ss_nm",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Sanitary Secratory Contact",
          field: "ss_cntct",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Assigned Trips",
          field: "asgnd_trps",
          alignment: "center",
        },
        {
          headerName: "Today Travelled Trips",
          field: "tdy_trvl_trps",
          alignment: "center",
          width: "auto",
        },
        {
          headerName: "Today Travelled Distance in Kms",
          field: "tdy_trvl_dst",
          alignment: "center",
          width: "auto",
        },
      ];
    } else if (this.clntDtls[0].clnt_id != 7) {
      this.vehclesTblecolumnDefs = [
        {
          headerName: "S.No",
          field: "sno",
          alignment: "center",
          width: 100,
          filter: false,
        },
        {
          headerName: "ULB",
          field: "tnt_nm",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Vehicle Number",
          field: "asrt_nm",
          alignment: "left",
          width: "auto",
          cellTemplate: "vehicleTemplate",
        },
        {
          headerName: "Vehicle Category",
          field: "asrt_ctgry_nm",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Vehicle Type",
          field: "vhcl_type_nm",
          alignment: "center",
          width: 100,
        },
        {
          headerName: "Vehicle Status",
          field: "asrt_sts_nm",
          alignment: "center",
          width: 100,
          cellTemplate: "vehicleStatusTemplate",
        },
        {
          headerName: "Ignition",
          field: "igntn_dsply",
          alignment: "center",
          width: 100,
          cellTemplate: "ignitionTemplate",
        },
        {
          headerName: "Operational Status",
          field: "opr_sts_nm",
          alignment: "center",
          width: 120,
          cellTemplate: "operationalStatusTemplate",
        },
        {
          headerName: "Vendor Name",
          field: "vndr_nm",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Driver Name",
          field: "crw_nm",
          alignment: "left",
          width: "auto",
          cellTemplate: "driverTemplate",
        },
        {
          headerName: "Driver Contact",
          field: "crw_ph",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Assigned Trips",
          field: "asgnd_trps",
          alignment: "center",
          width: "auto",
        },
        {
          headerName: "Today Travelled Trips",
          field: "tdy_trvl_trps",
          alignment: "center",
          width: "auto",
        },
        {
          headerName: "Today Travelled Distance in Kms",
          field: "tdy_trvl_dst",
          alignment: "center",
          width: "auto",
        },
      ];
    } else {
      this.vehclesTblecolumnDefs = [
        {
          headerName: "S.No",
          field: "sno",
          alignment: "center",
          width: 100,
          filter: false,
        },
        { headerName: "ULB", field: "tnt_nm", alignment: "left", width: 180 },
        {
          headerName: "Vehicle Number",
          field: "asrt_nm",
          alignment: "left",
          width: 180,
          cellTemplate: "vehicleTemplate",
        },
        {
          headerName: "Vehicle Category",
          field: "asrt_ctgry_nm",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Vehicle Type",
          field: "vhcl_type_nm",
          alignment: "center",
          width: 100,
        },
        {
          headerName: "Vehicle Status",
          field: "asrt_sts_nm",
          alignment: "center",
          width: 100,
          cellTemplate: "vehicleStatusTemplate",
        },
        {
          headerName: "Ignition",
          field: "igntn_dsply",
          alignment: "center",
          width: 100,
          cellTemplate: "ignitionTemplate",
        },
        {
          headerName: "Operational Status",
          field: "opr_sts_nm",
          alignment: "center",
          width: 120,
          cellTemplate: "operationalStatusTemplate",
        },
        {
          headerName: "Driver Name",
          field: "crw_nm",
          alignment: "left",
          width: "auto",
          cellTemplate: "driverTemplate",
        },
        {
          headerName: "Driver Contact",
          field: "crw_ph",
          alignment: "left",
          width: "auto",
        },
        {
          headerName: "Assigned Trips",
          field: "asgnd_trps",
          alignment: "center",
          width: "auto",
        },
        {
          headerName: "Today Travelled Trips",
          field: "tdy_trvl_trps",
          alignment: "center",
          width: "auto",
        },
        {
          headerName: "Today Travelled Distance in Kms",
          field: "tdy_trvl_dst",
          alignment: "center",
          width: "auto",
        },
      ];
    }
  }
  scrollTrpsTbl() {
    if (this.tripsTableRef && this.tripsTableRef.nativeElement) {
      this.tripsTableRef.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
  scrollVehTbl() {
    if (this.vehclesTableRef && this.vehclesTableRef.nativeElement) {
      this.vehclesTableRef.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
  scrollOperationalTbl() {
    if (this.operationalTableRef && this.operationalTableRef.nativeElement) {
      this.operationalTableRef.nativeElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
  reset() {
    this.sortedVehData("all");
    this.sortedTrvlData("all");
    this.getVehicleswiseData(this.slctdDt, this.selectedtenant);
  }
  toggleFilterPanel(forceState?: boolean) {
    this.filterPanelOpen =
      forceState !== undefined ? forceState : !this.filterPanelOpen;
  }

  selectCard(cardType: string) {
    this.selectedCard = cardType;

    // Scroll to relevant section when card is selected
    this.timeoutHandles.push(
      setTimeout(() => {
        if (cardType === "vehicles" && this.vehclesTableRef) {
          this.scrollVehTbl();
        } else if (cardType === "trips" && this.tripsTableRef) {
          this.scrollTrpsTbl();
        } else if (cardType === "operational" && this.operationalTableRef) {
          this.scrollOperationalTbl();
        }
      }, 100)
    );
  }

  toggleOperationalView(view: string) {
    this.operationalView = view;
    if (view === "graph") {
      this.timeoutHandles.push(
        setTimeout(() => {
          this.get_lst7DaysDistanceDta(this.slctdDt, this.selectedtenant);
        }, 100)
      );
    }
  }

  toggleTripsView(view: string) {
    this.tripsView = view;
    if (view === "graph") {
      this.timeoutHandles.push(
        setTimeout(() => {
          this.get_lst7DaysTrpsDta(this.slctdDt, this.selectedtenant);
        }, 100)
      );
    }
  }

  /**
   * Get VMU Maintained Data (CDMA and ULB sections)
   */
  getVmuMaintainedData(): void {
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    const postData = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
    };

    let rte = `dashboard/enterprise/get_vmu_maintained_data/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = res["data"];
            if (Array.isArray(data) && data.length > 0) {
              const cdmaTotal = data[0].cdma_total || 0;
              const cdmaOperated = data[0].cdma_operated || 0;
              const ulbTotal = data[0].ulb_total || 0;
              const ulbOperated = data[0].ulb_operated || 0;

              this.vmuMaintainedData = {
                cdma: {
                  total: cdmaTotal,
                  operated: cdmaOperated,
                  notOperated: data[0].cdma_not_operated || 0,
                  operatedPercent:
                    cdmaTotal > 0
                      ? Math.round((cdmaOperated / cdmaTotal) * 100 * 10) / 10
                      : 0,
                },
                ulb: {
                  total: ulbTotal,
                  operated: ulbOperated,
                  notOperated: data[0].ulb_not_operated || 0,
                  operatedPercent:
                    ulbTotal > 0
                      ? Math.round((ulbOperated / ulbTotal) * 100 * 10) / 10
                      : 0,
                },
              };
            }
          }
        },
        (err) => {
          console.error("Error fetching VMU maintained data:", err);
        }
      );
  }

  /**
   * Get Driver Type Counts (OWN/APCOS/CONTRACT)
   */
  getDriverTypeCounts(): void {
    const postData = {
      slctd_tnt: this.selectedtenant,
      dt: moment(this.slctdDt).format("YYYY-MM-DD"),
    };

    let rte = `dashboard/enterprise/get_driver_type_counts/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              this.driverTypeCounts = {
                total: data.total || data.total_count || 0,
                own: data.own || data.own_count || 0,
                apcos: data.apcos || data.apcos_count || 0,
                contract: data.contract || data.contract_count || 0,
                own_attended: data.own_attended || 0,
                own_not_attended: data.own_not_attended || 0,
                apcos_attended: data.apcos_attended || 0,
                apcos_not_attended: data.apcos_not_attended || 0,
                contract_attended: data.contract_attended || 0,
                contract_not_attended: data.contract_not_attended || 0,
              };
              if (!this.driverTypeCounts.total) {
                this.driverTypeCounts.total =
                  this.driverTypeCounts.own +
                  this.driverTypeCounts.apcos +
                  this.driverTypeCounts.contract;
              }
            }
          }
        },
        (err) => {
          console.error("Error fetching driver type counts:", err);
        }
      );
  }

  /**
   * Get Fuel Summary Monthly (current + previous month)
   */
  getFuelSummaryMonthly(): void {
    const postData = {
      slctd_tnt: this.selectedtenant,
    };

    let rte = `dashboard/enterprise/get_fuel_summary_monthly/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const dataArray = res["data"];
            if (Array.isArray(dataArray) && dataArray.length > 0) {
              const currentMonthData = dataArray[0];
              const prevMonthData = dataArray.length > 1 ? dataArray[1] : null;

              this.currentMonthLabel =
                currentMonthData.month_label || moment().format("MMM YYYY");
              this.previousMonthLabel =
                prevMonthData?.month_label ||
                moment().subtract(1, "month").format("MMM YYYY");

              this.fuelCardData = {
                totalUlbsFilled: currentMonthData.ulbs_count || 0,
                totalUlbsNotFilled: currentMonthData.ulbs_not_filled || 0,
                totalLitres: currentMonthData.total_litres || 0,
                totalAmount: currentMonthData.total_amount || 0,
                totalEntries: currentMonthData.total_entries || 0,
                vehiclesCount: currentMonthData.vehicles_fueled || 0,
                diesel: {
                  count: currentMonthData.diesel_count || 0,
                  litres: currentMonthData.diesel_litres || 0,
                  amount: currentMonthData.diesel_amount || 0,
                },
                petrol: {
                  count: currentMonthData.petrol_count || 0,
                  litres: currentMonthData.petrol_litres || 0,
                  amount: currentMonthData.petrol_amount || 0,
                },
                cng: {
                  count: currentMonthData.cng_count || 0,
                  kg: currentMonthData.cng_kg || 0,
                  amount: currentMonthData.cng_amount || 0,
                },
                mileageVarianceCount: 0,
              };

              if (prevMonthData) {
                this.prevMonthFuelData = {
                  totalUlbsFilled: prevMonthData.ulbs_count || 0,
                  totalUlbsNotFilled: prevMonthData.ulbs_not_filled || 0,
                  totalLitres: prevMonthData.total_litres || 0,
                  totalAmount: prevMonthData.total_amount || 0,
                  totalEntries: prevMonthData.total_entries || 0,
                  vehiclesCount: prevMonthData.vehicles_fueled || 0,
                  diesel: {
                    count: prevMonthData.diesel_count || 0,
                    litres: prevMonthData.diesel_litres || 0,
                    amount: prevMonthData.diesel_amount || 0,
                  },
                  petrol: {
                    count: prevMonthData.petrol_count || 0,
                    litres: prevMonthData.petrol_litres || 0,
                    amount: prevMonthData.petrol_amount || 0,
                  },
                  cng: {
                    count: prevMonthData.cng_count || 0,
                    kg: prevMonthData.cng_kg || 0,
                    amount: prevMonthData.cng_amount || 0,
                  },
                };
              }
            }
          }
        },
        (err) => {
          console.error("Error fetching fuel summary monthly data:", err);
        }
      );

    this.getMileageVarianceData();
  }

  /**
   * Get Mileage Variance Data
   */
  getMileageVarianceData(): void {
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    const postData = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
    };

    let rte = `dashboard/enterprise/get_mileage_variance/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              this.fuelCardData.mileageVarianceCount =
                data.mileage_variance_count || data.variance_count || 0;
            }
          }
        },
        (err) => {
          console.error("Error fetching mileage variance data:", err);
        }
      );
  }

  /**
   * Get Fuel Last 7 Days Data for Graph
   */
  getFuelLast7DaysData(): void {
    // Check if chart container exists in DOM
    if (!document.getElementById("fuelLast7DaysChart")) {
      return;
    }
    if (this.chart6) {
      this.chart6.dispose();
    }

    let chart = am4core.create("fuelLast7DaysChart", am4charts.XYChart);
    this.chart6 = chart;
    chart.data = [];

    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    const postData = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
      days: 7,
    };

    let rte = `dashboard/enterprise/get_fuel_last7days/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"] && res["data"].length > 0) {
            this.fuelLast7DaysData = res["data"];
            chart.data = this.fuelLast7DaysData;

            let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "dt";
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.renderer.minGridDistance = 30;
            categoryAxis.renderer.labels.template.fontSize = 11;
            categoryAxis.title.text = `Date (${this.curYr})`;
            categoryAxis.title.fontSize = 12;

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = "Litres / KG";
            valueAxis.title.fontSize = 12;
            valueAxis.renderer.labels.template.fontSize = 11;

            let dieselSeries = chart.series.push(new am4charts.ColumnSeries());
            dieselSeries.dataFields.valueY = "diesel_litres";
            dieselSeries.dataFields.categoryX = "dt";
            dieselSeries.name = "Diesel (L)";
            dieselSeries.stacked = true;
            dieselSeries.columns.template.tooltipText =
              "{categoryX}\nDiesel: [bold]{valueY} L[/]\nAmount: ₹{diesel_amount}";
            dieselSeries.columns.template.fill = am4core.color("#fb923c");
            dieselSeries.columns.template.stroke = am4core.color("#ea580c");
            dieselSeries.columns.template.strokeWidth = 1;

            let petrolSeries = chart.series.push(new am4charts.ColumnSeries());
            petrolSeries.dataFields.valueY = "petrol_litres";
            petrolSeries.dataFields.categoryX = "dt";
            petrolSeries.name = "Petrol (L)";
            petrolSeries.stacked = true;
            petrolSeries.columns.template.tooltipText =
              "{categoryX}\nPetrol: [bold]{valueY} L[/]\nAmount: ₹{petrol_amount}";
            petrolSeries.columns.template.fill = am4core.color("#8b5cf6");
            petrolSeries.columns.template.stroke = am4core.color("#7c3aed");
            petrolSeries.columns.template.strokeWidth = 1;

            let cngSeries = chart.series.push(new am4charts.ColumnSeries());
            cngSeries.dataFields.valueY = "cng_kg";
            cngSeries.dataFields.categoryX = "dt";
            cngSeries.name = "CNG (KG)";
            cngSeries.stacked = true;
            cngSeries.columns.template.tooltipText =
              "{categoryX}\nCNG: [bold]{valueY} KG[/]\nAmount: ₹{cng_amount}";
            cngSeries.columns.template.fill = am4core.color("#22c55e");
            cngSeries.columns.template.stroke = am4core.color("#16a34a");
            cngSeries.columns.template.strokeWidth = 1;

            chart.series.each((series) => {
              if (series instanceof am4charts.ColumnSeries) {
                series.columns.template.column.cornerRadiusTopLeft = 3;
                series.columns.template.column.cornerRadiusTopRight = 3;
                series.columns.template.fillOpacity = 0.9;
              }
            });

            chart.legend = new am4charts.Legend();
            chart.legend.position = "bottom";
            chart.legend.fontSize = 11;
            chart.legend.markers.template.width = 12;
            chart.legend.markers.template.height = 12;

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.lineX.disabled = true;
            chart.cursor.lineY.disabled = true;
          }
        },
        (err) => {
          console.error("Error fetching fuel last 7 days data:", err);
        }
      );
  }

  // Format currency value with Indian locale
  formatCurrency(value: number): string {
    if (value === null || value === undefined || isNaN(value)) {
      return "₹0";
    }
    return this.currencyFormatter.format(value);
  }

  // Format number with Indian locale
  formatNumber(value: number): string {
    if (value === null || value === undefined || isNaN(value)) {
      return "0";
    }
    return this.numberFormatter.format(value);
  }

  ngOnDestroy(): void {
    // 1. Cancel all pending HTTP requests immediately
    this.destroy$.next();
    this.destroy$.complete();

    // 2. Clear all pending timeouts
    this.timeoutHandles.forEach((h) => clearTimeout(h));
    this.timeoutHandles = [];

    // 3. Dispose all amCharts instances
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
    if (this.chart2) {
      this.chart2.dispose();
      this.chart2 = null;
    }
    if (this.chart5) {
      this.chart5.dispose();
      this.chart5 = null;
    }
    if (this.chart6) {
      this.chart6.dispose();
      this.chart6 = null;
    }

    // 4. Clear all data arrays to free memory
    this.vehclesTble = [];
    this.vehclesTbleDup = [];
    this.top10OperatedVehicles = [];
    this.least10OperatedVehicles = [];
    this.tdyCoveredTrips = [];
    this.tripsTrvldDta = [];
    this.tripsTrvldDtaDup = [];
    this.rtDvtdTripsDta = [];
    this.swprsWrkngTmDta = [];
    this.ctgryWseCnts = [];
    this.cvrgDta = null;
    this.HsDta = null;
    this.cnt_dtls = [];
    this.VndrwseopratedvehclesTble = [];
    this.fuelLast7DaysData = [];
    this.tntLst = [];
    this.prmryTrpsCnt = [];
    this.scndryTrpsCnt = [];
    this.ttlDstncCnt = [];
    this.ttlTrpsCnt = [];

    // 5. Reset loading state
    if (this.hideLdrHandle) {
      clearTimeout(this.hideLdrHandle);
      this.hideLdrHandle = null;
    }
    this.loadingCount = 0;
    this.showLdr = false;
  }

  /**
   * Get Fuel Card Data for the selected ULB
   * Uses dashboard key (dbrd_ky) to differentiate between state (0) and ULB level
   * Returns: filled/not filled ULBs, diesel/petrol/CNG breakdown with counts, litres, amounts
   */
  getFuelCardData(funDt?, slctTnt?): void {
    const curDate = moment(funDt || this.slctdDt).format("YYYY-MM-DD");
    const postData = {
      dt: curDate,
      fromdt: curDate,
      todt: curDate,
      slctd_tnt: slctTnt || this.selectedtenant || 0,
    };

    let rte = `dashboard/enterprise/get_fuel_data/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              this.fuelCardData = {
                totalUlbsFilled:
                  data.total_ulbs_filled || data.ulbs_filled || 0,
                totalUlbsNotFilled:
                  data.total_ulbs_not_filled || data.ulbs_not_filled || 0,
                totalLitres: data.total_lt || data.total_litres || 0,
                totalAmount: data.total_am || data.total_amount || 0,
                totalEntries: data.total_entries || 0,
                vehiclesCount: data.vehicles_ct || data.vehicles_count || 0,
                diesel: {
                  count: data.dsl_ct || data.diesel_count || 0,
                  litres: data.dsl_lt || data.diesel_litres || 0,
                  amount: data.dsl_am || data.diesel_amount || 0,
                },
                petrol: {
                  count: data.ptrl_ct || data.petrol_count || 0,
                  litres: data.ptrl_lt || data.petrol_litres || 0,
                  amount: data.ptrl_am || data.petrol_amount || 0,
                },
                cng: {
                  count: data.cng_ct || data.cng_count || 0,
                  kg: data.cng_lt || data.cng_kg || 0,
                  amount: data.cng_am || data.cng_amount || 0,
                },
              };
            }
            // console.log('Fuel Card Data:', this.fuelCardData);
          }
        },
        (err) => {
          console.error("Error fetching fuel data:", err);
        }
      );
  }

  /**
   * Get Vehicle Live Status (Total, Online, Running, Offline, Parked, Repair, 24hr Standby, Others)
   * Supports ULB-specific filtering via slctd_tnt parameter
   */
  getVehicleLiveStatus(slctTnt?): void {
    const postData = {
      slctd_tnt: slctTnt || this.selectedtenant || 0,
    };

    let rte = `dashboard/enterprise/get_vehicle_live_status/${this.dbrd_ky}`;
    this.apiServ
      .post(postData, rte)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              // Check if the selected date is today; historical dates should not show live running/parked/standby counts
              const isToday =
                moment(this.slctdDt).format("YYYY-MM-DD") ===
                moment().format("YYYY-MM-DD");

              this.vehicleLiveStatus = {
                total: data.total_count || data.total || 0,
                online: data.online_count || data.online || 0,
                running: isToday ? data.running_count || data.running || 0 : 0,
                offline: data.offline_count || data.offline || 0,
                parked: isToday ? data.parked_count || data.parked || 0 : 0,
                repair: data.repair_count || data.repair || 0,
                standby24hr: isToday
                  ? data.standby_24hr_count || data.standby_24hr || 0
                  : 0,
                onlineStandby24hr:
                  data.online_standby_24hr_count ||
                  data.online_standby_24hr ||
                  0,
                offline24hr:
                  data.offline_24hr_count ||
                  data.offline_24hr ||
                  data.standby_24hr_count ||
                  data.standby_24hr ||
                  0,
                others: data.others_count || data.others || 0,
              };
              // Calculate total if not provided by API
              if (!this.vehicleLiveStatus.total) {
                this.vehicleLiveStatus.total =
                  this.vehicleLiveStatus.online +
                  this.vehicleLiveStatus.offline;
              }
            }
            // console.log('Vehicle Live Status:', this.vehicleLiveStatus);
          }
        },
        (err) => {
          console.error("Error fetching vehicle live status:", err);
        }
      );
  }

  // Navigate to respective page from card arrow
  navigateToPage(path: string) {
    this.TransfereService.setLoclData("from_ulb_dashboard", true);
    this.route.navigate([`internal/${path}`]);
  }
}
